<template>
    <div class="container-fluid">
        <div class="row">
            <Navbar :class="[mobile?'navbar-admin':'navbar-admin-mobile']" v-show="toggle"></Navbar>
            <div :class="{ 'col-lg-12': !toggle }" class="col-lg-9 col-md-12 col-xs-12">
                <div class="container">
    
                    <Controls></Controls>
    
                    <!--seccion pasos-->
                    <div class="row">
                        <div class="col-12">
                            <button class="btn btn-default btn-custom-fixed" @click='toggle = !toggle'> 
                                                  <font-awesome-icon v-show="toggle" :style="{ color: '#FFFFFF', position: 'absolute', left: '0', top: '4' }" size="3x" :icon="['fas', 'chevron-left']" /> 
                                                  <font-awesome-icon v-show="!toggle" :style="{ color: '#FFFFFF', position: 'absolute', left: '0', top: '4' }" size="3x" :icon="['fas', 'chevron-right']" /> 
                                                </button>
    
                            <button class="d-xl-none btn btn-default btn-custom-fixed-mobile" @click='mobile = !mobile'> 
                                                  <font-awesome-icon style="z-index:2;"  :style="{ color: '#FFFFFF', position: 'absolute', left: '3', top: '2' }" size="2x" :icon="['fas', 'bars']" /> 
                                                </button>
    
                            <form-wizard :start-index.sync="stepIndex" @on-complete="registerAcommodation(acommodation)" title="" subtitle="" color="#662483" shape="hidden">
                                <tab-content title="paso 1">
    
                                    <div class="row mt-4 mb-4 morado height50 hidden-xs">
                                        <div class="avance-wrap mt-2 ">
                                            <div class="avance-circulo activo">
                                                <h4 class="h4-numero">1</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">2</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">3</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">4</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">5</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">6</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">7</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">8</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">9</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                        </div>
                                    </div>
    
    
                                    <p v-if="iso639_1 === 'es'" class="modalidad-text">
                                        Tipo de alojamiento
                                        <span class="text-center"> 
                                         <b-button style="background-color:white; border-radius: 50%; height: 35px; width: 35px;" v-b-tooltip.hover title="Se refiere al tipo de alojamiento que estás ofreciendo, por ejemplo si quieres ofrecer una habitación en un departamento seleccionar habitación privada."> <font-awesome-icon :style="{ color: '#5A287F'}" size="1x" :icon="['fa', 'info']" /></b-button>     
                                        </span>
                                    </p>
    
                                    <p v-else>
                                        Type of accommodation
                                        <span class="text-center"> 
                                                         <b-button style="background-color:white; border-radius: 50%; height: 35px; width: 35px;" v-b-tooltip.hover title="It refers to the type of accommodation you are offering, for example if you want to offer a room in an apartment select private room."> <font-awesome-icon :style="{ color: '#5A287F'}" size="1x" :icon="['fa', 'info']" /></b-button>     
                                                        </span>
                                    </p>
    
                                    <hr class="custom-100 mb-3">
    
                                    <b-card-group deck class="text-center">
                                        <b-card no-body :class="{ 'opt-active': !casa}" class="overflow-hidden" @click='vcasa'>
                                            <b-row no-gutters>
                                                <b-col md="4" class="text-center mt-3 pl-3">
                                                    <img v-if="!casa" width="50px" src="../assets/001-rent.svg">
                                                    <img v-else width="50px" src="../assets/casa.svg">
                                                </b-col>
                                                <b-col md="8">
                                                    <b-card-body>
                                                        <b-card-text v-if="iso639_1 === 'es'" class="mt-1 text-center ">
                                                            Casa entera
                                                        </b-card-text>
                                                        <b-card-text v-else class="mt-1 text-center ">
                                                            Entire house
                                                        </b-card-text>
                                                    </b-card-body>
                                                </b-col>
                                            </b-row>
                                        </b-card>
    
                                        <b-card no-body :class="{ 'opt-active': !departamento }" class="overflow-hidden" @click='vdepartamento'>
                                            <b-row no-gutters>
                                                <b-col md="4" class="text-center mt-3 pl-3">
                                                    <img v-if="!departamento" width="50px" src="../assets/depa-b.svg">
                                                    <img v-else width="50px" src="../assets/depa.svg">
                                                </b-col>
                                                <b-col md="8">
                                                    <b-card-body>
                                                        <b-card-text v-if="iso639_1 === 'es'" class="mt-1 text-center ">
                                                            Piso o Depto.
                                                        </b-card-text>
                                                        <b-card-text v-else class="mt-1 text-center ">
                                                            Floor or Dept.
                                                        </b-card-text>
                                                    </b-card-body>
                                                </b-col>
                                            </b-row>
                                        </b-card>
    
                                        <b-card no-body :class="{ 'opt-active': !habitacion }" class="overflow-hidden" @click='vhabitacion'>
                                            <b-row no-gutters>
                                                <b-col md="4" class="text-center mt-3 pl-3">
                                                    <img v-if="!habitacion" width="50px" src="../assets/002-room.svg">
                                                    <img v-else width="50px" src="../assets/002-room.svg">
                                                </b-col>
                                                <b-col md="8">
                                                    <b-card-body>
                                                        <b-card-text v-if="iso639_1 === 'es'" class="mt-1 text-center ">
                                                            Habitación privada
                                                        </b-card-text>
                                                        <b-card-text v-else class="mt-1 text-center ">
                                                            Private room
                                                        </b-card-text>
                                                    </b-card-body>
                                                </b-col>
                                            </b-row>
                                        </b-card>
    
                                        <b-card no-body :class="{ 'opt-active': !hcompartida }" class="overflow-hidden" @click='vhcompartida'>
                                            <b-row no-gutters>
                                                <b-col md="4" class="text-center mt-3 pl-3">
                                                    <img v-if="!habitacion" width="50px" src="../assets/003-bed.svg">
                                                    <img v-else width="50px" src="../assets/003-bed.svg">
                                                </b-col>
                                                <b-col md="8">
                                                    <b-card-body>
                                                        <b-card-text v-if="iso639_1 === 'es'" class="mt-1 text-cenNer">
                                                            Habitación compartida
                                                        </b-card-text>
                                                        <b-card-text v-else class="mt-1 text-cenNer">
                                                            Shared room
                                                        </b-card-text>
                                                    </b-card-body>
                                                </b-col>
                                            </b-row>
                                        </b-card>
    
                                    </b-card-group>
                                    <hr class="custom-100 mb-4">
                                    <!--empieza form-->
                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <label v-if="iso639_1 === 'es'">Dirección exacta de la propiedad</label>
                                            <label v-else>Exact address of the property</label>
                                            <vue-google-autocomplete types="" id="to_address" classname="form-control btn-sombra" placeholder="Los leones" v-on:placechanged="getToAddress" v-on:error="handleError" v-model="$v.acommodation.direccion.$model" @keyup="acommodation.direccion = null"
                                                :class="{'is-invalid': $v.acommodation.direccion.$invalid}">
                                            </vue-google-autocomplete>
                                            <div v-if="iso639_1 === 'es'">
                                                <p class="text-danger" v-if="!$v.acommodation.direccion.required">Este campo es requerido</p>
                                            </div>
                                            <div v-else>
                                                <p class="text-danger" v-if="!$v.acommodation.direccion.required">This field is required</p>
                                            </div>
    
                                        </div>
    
                                        <!--borrar este campo-->
                                        <!--
                                                        <div class="form-group col-md-3">
                                                          <label v-if="iso639_1 === 'es'">Número</label>
                                                          <label v-else>Number</label>
                                                          <input v-model="$v.acommodation.numero.$model" :class="{'is-invalid': $v.acommodation.numero.$error}" type="number"  class="form-control  btn-sombra"  placeholder="1054" min="1" max="999999">
                                                          <div v-if="iso639_1 === 'es'">
                                                            <p class="text-danger" v-if="!$v.acommodation.numero.required">Este campo es requerido</p>
                                                            <p class="text-danger" v-if="!$v.acommodation.numero.numeric">Este campo debe contener solo numeros positivos</p>
                                                            <p class="text-danger" v-if="!$v.acommodation.numero.minValue">Este campo debe ser mayor a 0</p>
                                                          </div>
                                                          <div v-else>
                                                            <p class="text-danger" v-if="!$v.acommodation.numero.required">This field is required</p>
                                                            <p class="text-danger" v-if="!$v.acommodation.numero.numeric">This field must contain only positive numbers</p>
                                                            <p class="text-danger" v-if="!$v.acommodation.numero.minValue">This field must be greater than 0</p>
                                                          </div>
                                                        </div>
                                                        -->
                                        <!--borrar este campo-->
    
    
                                        <div class="form-group col-md-6">
                                            <label v-if="iso639_1 === 'es'">N° de Depto / Casa</label>
                                            <label v-else>Department / House No.</label>
                                            <input v-model="$v.acommodation.ndc.$model" :class="{'is-invalid': $v.acommodation.ndc.$error}" type="text" class="form-control  btn-sombra" placeholder="2b">
                                            <div v-if="iso639_1 === 'es'">
                                                <p class="text-danger" v-if="!$v.acommodation.ndc.alphaNum">Este campo debe contener solo campos alphanumericos</p>
                                            </div>
                                            <div v-else>
                                                <p class="text-danger" v-if="!$v.acommodation.ndc.alphaNum">This field must contain only alphanumerical fields</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <label v-if="iso639_1 === 'es'">Metros cuadrados de la propiedad</label>
                                            <label v-else>Square meters of property</label>
                                            <input v-model="$v.acommodation.m2.$model" :class="{'is-invalid': $v.acommodation.m2.$error}" type="number" class="form-control  btn-sombra" placeholder="100 m2">
                                            <div v-if="iso639_1 === 'es'">
                                                <p class="text-danger" v-if="!$v.acommodation.m2.required">Este campo es requerido</p>
                                                <p class="text-danger" v-if="!$v.acommodation.m2.numeric">Este campo debe contener solo numeros positivos</p>
                                                <p class="text-danger" v-if="!$v.acommodation.m2.minValue">Este campo debe ser mayor a 0</p>
                                            </div>
                                            <div v-else>
                                                <p class="text-danger" v-if="!$v.acommodation.m2.required">This field is required</p>
                                                <p class="text-danger" v-if="!$v.acommodation.m2.numeric">This field must contain only positive numbers</p>
                                                <p class="text-danger" v-if="!$v.acommodation.m2.minValue">This field must be greater than 0</p>
                                            </div>
                                        </div>
    
    
                                        <div class="form-group col-md-6">
                                            <div v-if="iso639_1 === 'es'">
                                                <label v-show="!habitacion">Cuanta gente admite este alojamiento</label>
                                                <label v-show="!hcompartida">Cuanta gente admite esta habitación</label>
                                                <label v-show="!casa">Cuanta gente admite esta casa</label>
                                                <label v-show="!departamento">Cuanta gente admite este departamento</label>
                                            </div>
                                            <div v-else>
                                                <label v-show="!habitacion">How many people admit this accommodation</label>
                                                <label v-show="!hcompartida">How many people admit this room</label>
                                                <label v-show="!casa">How many people admit this house</label>
                                                <label v-show="!departamento">How many people admit this department</label>
                                            </div>
    
                                            <input class="form-control  btn-sombra" min="1" type="number" :class="{'is-invalid': $v.acommodation.maximo_huespedes.$error}" v-model="$v.acommodation.maximo_huespedes.$model">
                                            <div v-if="iso639_1 === 'es'">
                                                <p class="text-danger" v-if="!$v.acommodation.maximo_huespedes.required">Este campo es requerido</p>
                                                <p class="text-danger" v-if="!$v.acommodation.maximo_huespedes.numeric">Este campo debe contener solo numeros positivos</p>
                                                <p class="text-danger" v-if="!$v.acommodation.maximo_huespedes.minValue">Este campo debe ser mayor a 0</p>
                                            </div>
                                            <div>
                                                <p class="text-danger" v-if="!$v.acommodation.maximo_huespedes.required">This field is required</p>
                                                <p class="text-danger" v-if="!$v.acommodation.maximo_huespedes.numeric">This field must contain only positive numbers</p>
                                                <p class="text-danger" v-if="!$v.acommodation.maximo_huespedes.minValue">This field must be greater than 0</p>
                                            </div>
                                        </div>
    
                                        <div class="form-group col-md-6" v-show="habitacion && hcompartida">
                                            <label v-if="iso639_1 === 'es'">Habitaciones de la propiedad</label>
                                            <label v-else>Property Rooms</label>
                                            <div class="content-select">
                                                <select v-model="acommodation.habitaciones">
                                                                    <option value="" :key="index" v-for="(n, index) in 99" class="black">{{ n }}</option>
                                                                </select>
                                                <i></i>
                                            </div>
                                        </div>
    
                                    </div>
                                    <!-- este div aparece solo si es habitacion o hcompartida-->
                                    <div class="form-row" v-show="!habitacion || !hcompartida">
                                        <div class="form-group col-md-12">
                                            <label v-if="iso639_1 === 'es'">
                                                            ¿Este alojamiento es una residencia?
                                                          </label>
                                            <label v-else>
                                                            Is this accommodation a residence?
                                                          </label>
                                        </div>
                                        <div class="form-group col-md-6 mb-4 mt-4">
                                            <div class="form-check" style="padding-left:0;">
                                                <div class="row">
                                                    <div v-if="iso639_1 === 'es'" class="col-6 mt-2">
                                                        SI
                                                    </div>
                                                    <div v-else class="col-md-4 col-sm-6 mt-2">
                                                        YES
                                                    </div>
                                                    <div class="col-6">
                                                        <div class="square">
                                                            <input checked @change='residencia = !residencia' type="radio" id="radio.si" name="isrecidencia">
                                                            <label for="radio.si"></label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group col-md-6 mb-4 mt-4">
                                            <div class="form-check" style="padding-left:0;">
                                                <div class="row">
                                                    <div v-if="iso639_1 === 'es'" class="col-6 mt-2">
                                                        NO
                                                    </div>
                                                    <div v-else class="col-6 mt-2">
                                                        NOT
                                                    </div>
                                                    <div class="col-6">
                                                        <div class="square">
                                                            <input @change='residencia = !residencia' type="radio" id="radio.no" name="isrecidencia">
                                                            <label for="radio.no"></label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group col-md-4 mb-4 mt-4">
                                            <!--espacio vacio-->
                                            <br>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col-md-12">
                                            <label v-if="iso639_1 === 'es'">
                                                            Modalidad de arriendo (Puedes seleccionar una de ellas o ambas)
                                                          </label>
                                            <label v-else>
                                                           Rental mode (You can select one of them or both)
                                                          </label>
                                        </div>
    
    
                                        <div class="form-group col-md-4 mb-4 mt-4">
                                            <div class="form-check" style="padding-left:0;">
                                                <div class="row">
                                                    <div v-if="iso639_1 === 'es'" class="col-6 mt-2">
                                                        Diario
                                                    </div>
                                                    <div v-else class="col-6 mt-2">
                                                        Daily
                                                    </div>
                                                    <div class="col-6">
                                                        <div class="square">
                                                            <input @click="changeDiario" type="checkbox" id="checkbox.diario" v-model="diario">
                                                            <label for="checkbox.diario"></label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
    
    
                                        <div class="form-group col-md-4 mb-4 mt-4">
                                            <div class="form-check" style="padding-left:0;">
                                                <div class="row">
                                                    <div v-if="iso639_1 === 'es'" class="col-6 mt-2">
                                                        Mensual
                                                    </div>
                                                    <div v-else class="col-6 mt-2">
                                                        Monthly
                                                    </div>
                                                    <div class="col-6">
                                                        <div class="square">
                                                            <input @click="changeMensual" type="checkbox" id="checkbox.mensual" v-model="mensual">
                                                            <label for="checkbox.mensual"></label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
    
                                        <div class="form-group col-md-4 mb-4 mt-4">
                                            <div class="form-check" style="padding-left:0;">
                                                <div class="row">
                                                    <div v-if="iso639_1 === 'es'" class="col-6 mt-2">
                                                        Ambos
                                                    </div>
                                                    <div v-else class="col-6 mt-2">
                                                        Both of them
                                                    </div>
                                                    <div class="col-3">
                                                        <div class="square">
                                                            <input @click="changeAmbos" type="checkbox" id="checkbox.ambos" v-model="ambos">
                                                            <label for="checkbox.ambos"></label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
    
                                    </div>
    
                                    <div class="form-group mt-4">
                                        <label v-if="iso639_1 === 'es'">Que tipo de alojamiento ofreces ?</label>
                                        <label v-else>What type of accommodation do you offer?</label>
                                        <div class="content-select">
                                            <select v-if="iso639_1 === 'es'">
                                                                  <option  selected>Casa</option>
                                                                  <option class="black">Bed and Breakfast</option>
                                                                  <option class="black">Bungalow</option>
                                                                  <option class="black">Casa adosada</option>
                                                                  <option class="black">Chalet</option>
                                                                  <option class="black">Dormitorio para invitados</option>
                                                                  <option class="black">Departamento</option>
                                                                  <option class="black">Hotel Boutique</option>
                                                                  <option class="black">Cabaña</option>
                                                                  <option class="black">Hostal</option>
                                                                  <option class="black">Residencia</option>
                                                                  <option class="black">Bagpackers</option>
                                                              </select>
                                            <select v-else>
                                                                  <option  selected>Home</option>
                                                                  <option class="black">Bed and Breakfast</option>
                                                                  <option class="black">Bungalow</option>
                                                                  <option class="black">Terraced house</option>
                                                                  <option class="black">Chalet</option>
                                                                  <option class="black">Guest bedroom</option>
                                                                  <option class="black">Department</option>
                                                                  <option class="black">Boutique hotel</option>
                                                                  <option class="black">Cabin</option>
                                                                  <option class="black">Lodging house</option>
                                                                  <option class="black">Residence</option>
                                                                  <option class="black">Bagpackers</option>                                          
                                                              </select>
                                            <i></i>
                                        </div>
                                    </div>
                                    <!--termina form-->
                                </tab-content>
                                <tab-content title="paso 2">
    
                                    <div class="row mt-4 mb-4 morado height50 hidden-xs">
                                        <div class="avance-wrap mt-2 ">
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">1</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo activo">
                                                <h4 class="h4-numero">2</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">3</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">4</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">5</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">6</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">7</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">8</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">9</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <!--paso 2 -->
    
    
                                    <div class="row">
                                        <div class="col-lg-6 col-md-6 col-sm-12">
                                            <p v-if="iso639_1 === 'es'">
                                                Ponle un precio a tu alojamiento, escoge el tipo de moneda en que quieres registrar tu alojamiento
                                            </p>
                                            <p v-else>
                                                Put a price on your accommodation, choose the type of currency in which you want to register your accommodation
                                            </p>
                                        </div>
                                        <div class="col-lg-6 col-md-6 col-sm-12">
                                            <div class="col-lg-12 col-md-12 col-sm-12">
                                                <div class="content-select">
                                                    <select @change="setMonedaCambio(acommodation.tipo_moneda)" v-model="acommodation.tipo_moneda" class="btn-custom ind-0">
                                                                  <option value="es_CLP" selected >$ CLP</option>
                                                                  <option v-bind:value="moneda.moneda" :key="moneda.idtipo_cambio" v-for="moneda in tipocambio" class="black">
                                                                      <div v-if="moneda.moneda === 'en_US'">$ USD</div>
                                                                      <div v-else-if="moneda.moneda === 'en_GB'">£ GBP</div>
                                                                      <div v-else-if="moneda.moneda === 'it_IT'">€ EUR</div>
                                                                      <div v-else-if="moneda.moneda === 'es_AR'">$ ARS</div>
                                                                  </option>
                                                                  </select>
                                                    <i></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <hr class="custom-100 mb-3">
    
                                    <div class="row">
                                        <div class="col-xs-6 col-md-12 col-lg-6 seccion-2">
                                            <div v-show="!diario || mensual" class="form-group col-md-12">
                                                <!-- Traducion -->
                                                <p v-if="iso639_1 === 'es'">
                                                    Gasto Inmueble (arriendo mensual)
                                                    <span class="text-center"> 
                                                                <b-button @click="cambiarTip('Gasto Inmueble','Se refiere al valor base a cobrar por concepto de infraestructura e inmueble ofrecido.')" style="background-color:white; border-radius: 50%; height: 35px; width: 35px;"> <font-awesome-icon :style="{ color: '#5A287F'}" size="1x" :icon="['fa', 'info']" /></b-button>     
                                                                </span>
                                                </p>
                                                <p v-else>
                                                    Property Expense (monthly lease)
                                                    <span class="text-center"> 
                                                                <b-button @click="cambiarTip('Property Expense','Refers to the base value to be charged for infrastructure and real estate offered.')" style="background-color:white; border-radius: 50%; height: 35px; width: 35px;"> <font-awesome-icon :style="{ color: '#5A287F'}" size="1x" :icon="['fa', 'info']" /></b-button>     
                                                                </span>
                                                </p>

                                                <!-- Input gasto Inmueble -->
                                                <input type="number" placeholder="0" min='0' :class="{'is-invalid': $v.acommodation.gastoinmueble.$error}" class="form-control btn-sombra" v-model.number="$v.acommodation.gastoinmueble.$model">

                                                <div v-if="iso639_1 === 'es'">
                                                    <p class="text-danger" v-if="!$v.acommodation.gastoinmueble.required">Este campo es requerido</p>
                                                    <p class="text-danger" v-if="!$v.acommodation.gastoinmueble.numeric">Este campo debe contener solo numeros positivos</p>
                                                    <p class="text-danger" v-if="!$v.acommodation.gastoinmueble.minValue">Este campo debe ser mayor a 0</p>
                                                </div>
                                                <div v-else>
                                                    <p class="text-danger" v-if="!$v.acommodation.gastoinmueble.required">This field is required</p>
                                                    <p class="text-danger" v-if="!$v.acommodation.gastoinmueble.numeric">This field must contain only positive numbers</p>
                                                    <p class="text-danger" v-if="!$v.acommodation.gastoinmueble.minValue">This field must be greater than 0</p>
                                                </div>
                                            </div>
                                            <div v-show="!diario || mensual" class="form-group col-md-12">
                                                <!-- Traducion -->
                                                <p v-if="iso639_1 === 'es'">
                                                    Servicios básicos (Luz, agua, gas) (aproximado)
                                                    <span class="text-center"> 
                                                                <b-button @click="cambiarTip('Servicios básicos','Valor a cobrar por concepto de cuentas básicas del alojamiento, valor proporcional al uso que le dará el huésped. En house and flats te recomendamos fijar un precio que logre cubrir estos de manera efectiva.')" style="background-color:white; border-radius: 50%; height: 35px; width: 35px;"> <font-awesome-icon :style="{ color: '#5A287F'}" size="1x" :icon="['fa', 'info']" /></b-button>     
                                                                </span>
                                                </p>
                                                <p v-else>
                                                    Basic services (electricity, water, gas) (approximate)
                                                    <span class="text-center"> 
                                                                <b-button @click="cambiarTip('Basic services','Value to be charged for basic accommodation bills, value proportional to the use that the guest will give. In house and flats we recommend you set a price that can cover these effectively.')" style="background-color:white; border-radius: 50%; height: 35px; width: 35px;"> <font-awesome-icon :style="{ color: '#5A287F'}" size="1x" :icon="['fa', 'info']" /></b-button>     
                                                                </span>
                                                </p>

                                                <!-- Input Servicios Basicos -->
                                                <input type="number" placeholder="0" min="0" :class="{'is-invalid': $v.acommodation.serviciosb.$error}" class="form-control  btn-sombra" v-model.number="$v.acommodation.serviciosb.$model">
                                                <div v-if="iso639_1 === 'es'">
                                                    <p class="text-danger" v-if="!$v.acommodation.serviciosb.numeric">Este campo debe contener solo numeros positivos</p>
                                                </div>
                                                <div v-else>
                                                    <p class="text-danger" v-if="!$v.acommodation.serviciosb.numeric">This field must contain only positive numbers</p>
                                                </div>
                                            </div>
                                            <div v-show="!diario || mensual" class="form-group col-md-12">
                                                <!-- Traducion -->
                                                <p v-if="iso639_1 === 'es'">
                                                    Gastos Comunes (aproximado)
                                                    <span class="text-center"> 
                                                                <b-button @click="cambiarTip('Gastos Comunes','Valor a pagar correspondiente comúnmente a departamentos, al igual que en servicios básicos recomendamos fijar un precio que cubra efectivamente el valor mensualmente.')" style="background-color:white; border-radius: 50%; height: 35px; width: 35px;"> <font-awesome-icon :style="{ color: '#5A287F'}" size="1x" :icon="['fa', 'info']" /></b-button>     
                                                                </span>
                                                </p>
                                                <p v-else>
                                                    Common Expenses (approximate)
                                                    <span class="text-center"> 
                                                                <b-button @click="cambiarTip('Common Expenses','Value to be paid correspondingly to departments, as in basic services we recommend setting a price that effectively covers the value monthly.')" style="background-color:white; border-radius: 50%; height: 35px; width: 35px;" > <font-awesome-icon :style="{ color: '#5A287F'}" size="1x" :icon="['fa', 'info']" /></b-button>     
                                                                </span>
                                                </p>
                                                <!-- Input Gastos Comunes -->
                                                <input type="number" placeholder="0" min="0" :class="{'is-invalid': $v.acommodation.gastos_comunes.$error}" class="form-control  btn-sombra" v-model.number="$v.acommodation.gastos_comunes.$model">
                                                <div v-if="iso639_1 === 'es'">
                                                    <p class="text-danger" v-if="!$v.acommodation.gastos_comunes.numeric">Este campo debe contener solo numeros positivos</p>
                                                </div>
                                                <div v-else>
                                                    <p class="text-danger" v-if="!$v.acommodation.gastos_comunes.numeric">This field must contain only positive numbers</p>
                                                </div>
                                            </div>
                                            <div v-show="!diario || mensual" class="form-group col-md-12">
                                                <!-- Traducion -->
                                                <p v-if="iso639_1 === 'es'">
                                                    Limpieza (opcional)
                                                    <span class="text-center"> 
                                                                <b-button @click="cambiarTip('Limpieza','Valor correspondiente a la limpieza del lugar, es opcional.')" style="background-color:white; border-radius: 50%; height: 35px; width: 35px;"> <font-awesome-icon :style="{ color: '#5A287F'}" size="1x" :icon="['fa', 'info']" /></b-button>     
                                                                </span>
                                                </p>
                                                <p v-else>
                                                    Cleaning (optional)
                                                    <span class="text-center"> 
                                                                <b-button @click="cambiarTip('Cleaning','Value corresponding to the cleaning of the place, is optional.')" style="background-color:white; border-radius: 50%; height: 35px; width: 35px;"> <font-awesome-icon :style="{ color: '#5A287F'}" size="1x" :icon="['fa', 'info']" /></b-button>     
                                                                </span>
                                                </p>
                                                <!-- Input Limpieza -->
                                                <input type="number" placeholder="0" min="0" :class="{'is-invalid': $v.acommodation.limpieza.$error}" class="form-control  btn-sombra" v-model.number="$v.acommodation.limpieza.$model">
                                                <div v-if="iso639_1 === 'es'">
                                                    <p class="text-danger" v-if="!$v.acommodation.limpieza.numeric">Este campo debe contener solo numeros positivos</p>
                                                </div>
                                                <div v-else>
                                                    <p class="text-danger" v-if="!$v.acommodation.limpieza.numeric">This field must contain only positive numbers</p>
                                                </div>
                                            </div>
                                            <div v-show="!diario || mensual" class="form-group col-md-12">
                                                <!-- Traducion -->
                                                <p v-if="iso639_1 === 'es'">
                                                    Garantia
                                                    <span class="text-center"> 
                                                                <b-button @click="cambiarTip('Garantia','Monto que se entrega al anfitrión con el fin de asegurar el cumplimiento del pago y/o extravío, hurto o rompimiento de algún componente del alojamiento.')" style="background-color:white; border-radius: 50%; height: 35px; width: 35px;" > <font-awesome-icon :style="{ color: '#5A287F'}" size="1x" :icon="['fa', 'info']" /></b-button>     
                                                                </span>
                                                </p>
                                                <p v-else>
                                                    Warranty
                                                    <span class="text-center"> 
                                                                <b-button @click="cambiarTip('Warranty','Amount that is delivered to the host in order to ensure payment compliance and / or loss, theft or breakage of any component of the accommodation.')" style="background-color:white; border-radius: 50%; height: 35px; width: 35px;" > <font-awesome-icon :style="{ color: '#5A287F'}" size="1x" :icon="['fa', 'info']" /></b-button>     
                                                                </span>
                                                </p>
    
                                                <div v-if="!habitacion || !hcompartida">
                                                    <input v-if="iso639_1 === 'es'" :disabled="!habitacion || !hcompartida" type="text" class="form-control  btn-sombra" :value="foo" :name="foo">
                                                    <input v-else :disabled="!habitacion || !hcompartida" type="text" class="form-control  btn-sombra" :value="foo2" :name="foo2">
                                                </div>
                                                <div v-else>
                                                    <input disabled type="number" class="form-control btn-sombra" v-model.number="total">
                                                </div>
    
                                            </div>
                                            <div v-show="diario" class="form-group col-md-12">
                                                <!-- Traducion -->
                                                <p v-if="iso639_1 === 'es'">
                                                    Valor diario de arriendo
                                                    <span class="text-center"> 
                                                                <b-button @click="cambiarTip('Valor diario de arriendo','Valor a recibir correspondiente a una noche de permanencia en el alojamiento señalado, el pago por parte de House and Flats al anfitrión será por la totalidad de la estadía')" style="background-color:white; border-radius: 50%; height: 35px; width: 35px;" > <font-awesome-icon :style="{ color: '#5A287F'}" size="1x" :icon="['fa', 'info']" /></b-button>     
                                                                </span>
                                                </p>
                                                <p v-else>
                                                    Daily Lease Value
                                                    <span class="text-center"> 
                                                                <b-button @click="cambiarTip('Daily Lease Value','Value to receive corresponding to one night of stay in the indicated accommodation, the payment by House and Flats to the host will be for the entire stay')" style="background-color:white; border-radius: 50%; height: 35px; width: 35px;" > <font-awesome-icon :style="{ color: '#5A287F'}" size="1x" :icon="['fa', 'info']" /></b-button>     
                                                                </span>
                                                </p>
                                                <!-- Input Valor Diario -->
                                                <input type="number" placeholder="0" :class="{'is-invalid': $v.acommodation.vdiario.$error}" class="form-control btn-sombra" v-model.number="$v.acommodation.vdiario.$model">
                                                <div v-if="iso639_1 === 'es'">
                                                    <p class="text-danger" v-if="!$v.acommodation.vdiario.required">Este campo es requerido</p>
                                                    <p class="text-danger" v-if="!$v.acommodation.vdiario.numeric">Este campo debe contener solo numeros positivos</p>
                                                    <p class="text-danger" v-if="!$v.acommodation.vdiario.minValue">Este campo debe ser mayor a 0</p>
                                                </div>
                                                <div v-else>
                                                    <p class="text-danger" v-if="!$v.acommodation.vdiario.required">This field is required</p>
                                                    <p class="text-danger" v-if="!$v.acommodation.vdiario.numeric">This field must contain only positive numbers</p>
                                                    <p class="text-danger" v-if="!$v.acommodation.vdiario.minValue">This field must be greater than 0</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xs-6 col-md-12 col-lg-6">
                                            <b-card no-body class="overflow-hidden">
                                                <b-row no-gutters>
                                                    <b-col md="6">
                                                        <div class="circular--portrait">
                                                            <div class="text-center mt-4">
                                                                <img src="../assets/disfruta.png" />
                                                            </div>
                                                        </div>
                                                    </b-col>
                                                    <b-col v-if="iso639_1 === 'es'" md="6">
                                                        <b-card-body v-if="!tip" title="Título del tip:" class="mt-4 text-center">
                                                            <b-card-text>
                                                                Aquí va a apareciendo la info de cada campo cuando se aprieta el icono (?) se debe cargar aquí el mensaje.
                                                            </b-card-text>
                                                        </b-card-body>
                                                        <b-card-body v-else :title="titulo" class="mt-4 text-center">
                                                            <b-card-text>
                                                                {{tip}}
                                                                <br><br>
                                                            </b-card-text>
                                                        </b-card-body>
                                                    </b-col>
                                                    <b-col v-else md="6">
                                                        <b-card-body v-if="!tip" title="Tip Title:" class="mt-4 text-center">
                                                            <b-card-text>
                                                                Here the info of each field will appear when the icon (?) Is pressed                                               the message must be loaded here.
                                                            </b-card-text>
                                                        </b-card-body>
                                                        <b-card-body v-else :title="titulo" class="mt-4 text-center">
                                                            <b-card-text>
                                                                {{tip}}
                                                                <br><br>
                                                            </b-card-text>
                                                        </b-card-body>
                                                    </b-col>
                                                </b-row>
                                            </b-card>
    
    
                                            <b-card v-show="!diario || mensual" header-tag="header" footer-tag="footer" class="mt-3">
                                                <b-card-text>
                                                    <div class="row">
                                                        <div v-if="iso639_1 === 'es'" class="col-6 text-left">
                                                            Gasto Inmueble
                                                        </div>
                                                        <div v-else class="col-6 text-left">
                                                            Property Expense
                                                        </div>
                                                        <div class="col-6 text-right">
                                                            <b>
                                                                    <div v-if="acommodation.tipo_moneda === 'en_US'">${{cambiarMilles(acommodation.gastoinmueble)}} USD</div>
                                                                    <div v-else-if="acommodation.tipo_moneda === 'en_GB'">£{{cambiarMilles(acommodation.gastoinmueble)}} GBP</div>
                                                                    <div v-else-if="acommodation.tipo_moneda === 'it_IT'">€{{cambiarMilles(acommodation.gastoinmueble)}} EUR</div>
                                                                    <div v-else-if="acommodation.tipo_moneda === 'es_AR'">${{cambiarMilles(acommodation.gastoinmueble)}} ARS</div>
                                                                    <div v-else>${{cambiarMilles(acommodation.gastoinmueble)}} CLP</div>
                                                                    </b>
                                                        </div>
                                                    </div>
                                                    <hr class="custom-100 mb-3">
    
                                                    <div class="row">
                                                        <div v-if="iso639_1 === 'es'" class="col-6 text-left">
                                                            Servicios básicos
                                                        </div>
                                                        <div v-else class="col-6 text-left">
                                                            Basic services
                                                        </div>
                                                        <div class="col-6 text-right">
                                                            <b> 
                                                                    <div v-if="acommodation.tipo_moneda === 'en_US'">${{cambiarMilles(acommodation.serviciosb)}} USD</div>
                                                                    <div v-else-if="acommodation.tipo_moneda === 'en_GB'">£{{cambiarMilles(acommodation.serviciosb)}} GBP</div>
                                                                    <div v-else-if="acommodation.tipo_moneda === 'it_IT'">€{{cambiarMilles(acommodation.serviciosb)}} EUR</div>
                                                                    <div v-else-if="acommodation.tipo_moneda === 'es_AR'">${{cambiarMilles(acommodation.serviciosb)}} ARS</div>
                                                                    <div v-else>${{cambiarMilles(acommodation.serviciosb)}} CLP</div>
                                                                    </b>
                                                        </div>
                                                    </div>
                                                    <hr class="custom-100 mb-3">
    
                                                    <div class="row">
                                                        <div v-if="iso639_1 === 'es'" class="col-6 text-left">
                                                            Gastos comunes
                                                        </div>
                                                        <div v-else class="col-6 text-left">
                                                            Common expenses
                                                        </div>
                                                        <div class="col-6 text-right">
                                                            <b>
                                                                    <div v-if="acommodation.tipo_moneda === 'en_US'">${{cambiarMilles(acommodation.gastos_comunes)}} USD</div>
                                                                    <div v-else-if="acommodation.tipo_moneda === 'en_GB'">£{{cambiarMilles(acommodation.gastos_comunes)}} GBP</div>
                                                                    <div v-else-if="acommodation.tipo_moneda === 'it_IT'">€{{cambiarMilles(acommodation.gastos_comunes)}} EUR</div>
                                                                    <div v-else-if="acommodation.tipo_moneda === 'es_AR'">${{cambiarMilles(acommodation.gastos_comunes)}} ARS</div>
                                                                    <div v-else>${{cambiarMilles(acommodation.gastos_comunes)}} CLP</div>
                                                                    </b>
                                                        </div>
                                                    </div>
                                                    <hr class="custom-100 mb-3">
    
                                                    <div class="row">
                                                        <div v-if="iso639_1 === 'es'" class="col-6 text-left">
                                                            Limpieza
                                                        </div>
                                                        <div v-else class="col-6 text-left">
                                                            Cleaning
                                                        </div>
                                                        <div class="col-6 text-right">
                                                            <b>
                                                                    <div v-if="acommodation.tipo_moneda === 'en_US'">${{cambiarMilles(acommodation.limpieza)}} USD</div>
                                                                    <div v-else-if="acommodation.tipo_moneda === 'en_GB'">£{{cambiarMilles(acommodation.limpieza)}} GBP</div>
                                                                    <div v-else-if="acommodation.tipo_moneda === 'it_IT'">€{{cambiarMilles(acommodation.limpieza)}} EUR</div>
                                                                    <div v-else-if="acommodation.tipo_moneda === 'es_AR'">${{cambiarMilles(acommodation.limpieza)}} ARS</div>
                                                                    <div v-else>${{cambiarMilles(acommodation.limpieza)}} CLP</div>    
                                                                    </b>
                                                        </div>
                                                    </div>
                                                    <hr class="custom-100 mb-3">
    
                                                    <div class="row">
                                                        <div v-if="iso639_1 === 'es'" class="col-6 text-left">
                                                            Recibirás mensualmente:
                                                        </div>
                                                        <div v-else class="col-6 text-left">
                                                            You will receive monthly:
                                                        </div>
                                                        <div class="col-6 text-right">
                                                            <b>
                                                                    <div v-if="acommodation.tipo_moneda === 'en_US'">${{total}} USD</div>
                                                                    <div v-else-if="acommodation.tipo_moneda === 'en_GB'">£{{total}} GBP</div>
                                                                    <div v-else-if="acommodation.tipo_moneda === 'it_IT'">€{{total}} EUR</div>
                                                                    <div v-else-if="acommodation.tipo_moneda === 'es_AR'">${{total}} ARS</div>
                                                                    <div v-else>${{total}} CLP</div>  
                                                                    </b>
                                                        </div>
                                                    </div>
                                                </b-card-text>
                                                <em slot="footer">
                                                                <div class="row">
                                                                  <div v-if="iso639_1 === 'es'" class="col-6 text-left">
                                                                    Garantia
                                                                  </div>
                                                                  <div v-else class="col-6 text-left">
                                                                    Warranty
                                                                  </div>
                                                                  <div v-if="!habitacion || !hcompartida" class="col-6 text-right">
                                                                    <div style="display: inline;" v-if="iso639_1 === 'es'">
                                                                      NO APLICA
                                                                    </div>
                                                                    <div style="display: inline;" v-else >
                                                                      DOES NOT APPLY
                                                                    </div>
                                                                  </div>
                                                                  <div v-else class="col-6 text-right">
                                                                    <div v-if="acommodation.tipo_moneda === 'en_US'">${{total}} USD</div>
                                                                    <div v-else-if="acommodation.tipo_moneda === 'en_GB'">£{{total}} GBP</div>
                                                                    <div v-else-if="acommodation.tipo_moneda === 'it_IT'">€{{total}} EUR</div>
                                                                    <div v-else-if="acommodation.tipo_moneda === 'es_AR'">${{total}} ARS</div>
                                                                    <div v-else>${{total}} CLP</div>     
                                                                  </div>
                                                                </div>                                         
                                                              </em>
                                            </b-card>
    
                                            <div v-if="iso639_1 === 'es'" v-show="diario" class="col-12 text-center mt-4 pt-4 pb-4 recibe">
                                                En caso de arriendo diario recibirás
    
                                                <div v-if="acommodation.tipo_moneda === 'en_US'">${{cambiarMilles(acommodation.vdiario)}} USD</div>
                                                <div v-else-if="acommodation.tipo_moneda === 'en_GB'">£{{cambiarMilles(acommodation.vdiario)}} GBP</div>
                                                <div v-else-if="acommodation.tipo_moneda === 'it_IT'">€{{cambiarMilles(acommodation.vdiario)}} EUR</div>
                                                <div v-else-if="acommodation.tipo_moneda === 'es_AR'">${{cambiarMilles(acommodation.vdiario)}} ARS</div>
                                                <div v-else>${{cambiarMilles(acommodation.vdiario)}} CLP</div>
                                            </div>
                                            <div v-else v-show="diario" class="col-12 text-center mt-4 pt-4 pb-4 recibe">
                                                In case of daily rental you will receive
    
                                                <div v-if="acommodation.tipo_moneda === 'en_US'">${{cambiarMilles(acommodation.vdiario)}} USD</div>
                                                <div v-else-if="acommodation.tipo_moneda === 'en_GB'">£{{cambiarMilles(acommodation.vdiario)}} GBP</div>
                                                <div v-else-if="acommodation.tipo_moneda === 'it_IT'">€{{cambiarMilles(acommodation.vdiario)}} EUR</div>
                                                <div v-else-if="acommodation.tipo_moneda === 'es_AR'">${{cambiarMilles(acommodation.vdiario)}} ARS</div>
                                                <div v-else>${{cambiarMilles(acommodation.vdiario)}} CLP</div>
                                            </div>
    
                                        </div>
                                    </div>
                                    <!--fin paso 2-->
                                </tab-content>
                                <tab-content title="Paso 3" class="mb-4">
    
                                    <div class="row mt-4 mb-4 morado height50 hidden-xs">
                                        <div class="avance-wrap mt-2 ">
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">1</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">2</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo activo">
                                                <h4 class="h4-numero">3</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">4</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">5</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">6</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">7</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">8</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">9</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <!--inicio paso 3-->
    
                                    <p v-if="iso639_1 === 'es'">
                                        Los huéspedes necesitan ver tu alojamiento
                                    </p>
                                    <p v-else>
                                        Guests need to see your accommodation
                                    </p>
                                    <hr class="custom-100 mb-3">
    
                                    <p v-if="iso639_1 === 'es'">
                                        En House & Flats exigimos un mínimo de fotos para que tu publicación sea de calidad
                                    </p>
                                    <p v-else>
                                        In House & Flats we require a minimum of photos so that your publication is of quality
                                    </p>
    
    
                                    <div class="row text-center">
                                        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3 mt-2">
    
                                            <span @click="preview.habitacion = false; acommodation.fotos.habitacion = null" v-if="acommodation.fotos.habitacion" class="close-pic">X</span>
    
                                            <div class="c-file-input js-file-input">
                                                <div class="c-file-input__indicator">
                                                    <img src="../assets/habitacion.svg">
                                                    <img v-show="preview.habitacion" style="width: 160%; position:relative; margin-top:-100px; margin-left:-30px;" :style="{ backgroundImage: 'url(' + preview.habitacion + '  no-repeat center center fixed background-size: cover;)' }" :src="preview.habitacion"
                                                    />
    
                                                    <div v-if="iso639_1 === 'es'">
                                                        Agrega foto Habitación
                                                    </div>
                                                    <div v-else>
                                                        Add photo Room
                                                    </div>
                                                    <p style="margin-left:-5px;" class="text-danger" v-if="!$v.acommodation.fotos.habitacion.required">Requerido</p>
                                                    <!-- <div class="col-12 cortar">                                   
                                                              {{acommodation.fotos.habitacion ? acommodation.fotos.habitacion.name: ''}}
                                                              <p style="margin-left:-5px;" class="text-danger" v-if="!$v.acommodation.fotos.habitacion.required">Requerido</p>
                                                              </div> -->
                                                </div>
                                                <label class="c-file-input__label js-file-input__label" for="fhabitacion">    
                                                              <input
                                                                id="fhabitacion"
                                                                type="button" 
                                                                name="attachment" 
                                                                class="c-file-input__field js-file-input__field"
                                                                onclick="document.getElementById('habitacion').click();" 
                                                                >
                                                            </label>
                                                <b-form-file @change="onFileChangeHabitacion" id="habitacion" v-model="$v.acommodation.fotos.habitacion.$model" style="display:none;"></b-form-file>
                                            </div>
                                        </div>
                                        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3 mt-2">
    
                                            <span @click="preview.habitacion2 = false; acommodation.fotos.habitacion2 = null" v-if="acommodation.fotos.habitacion2" class="close-pic">X</span>
    
                                            <div class="c-file-input js-file-input">
                                                <div class="c-file-input__indicator">
                                                    <img src="../assets/habitacion.svg">
                                                    <img v-show="preview.habitacion2" style="width: 160%; position:relative; margin-top:-100px; margin-left:-20px;" :style="{ backgroundImage: 'url(' + preview.habitacion2 + '  no-repeat center center fixed background-size: cover;)' }" :src="preview.habitacion2"
                                                    />
                                                    <div v-if="iso639_1 === 'es'">
                                                        Agrega foto Habitación
                                                    </div>
                                                    <div v-else>
                                                        Add photo Room
                                                    </div>
                                                    <p style="margin-left:-5px;" class="text-danger" v-if="!$v.acommodation.fotos.habitacion2.required">Requerido</p>
                                                    <!-- <div class="col-12 cortar">
                                                              {{acommodation.fotos.habitacion2 ? acommodation.fotos.habitacion2.name: ''}}
                                                              </div> -->
                                                </div>
                                                <label class="c-file-input__label js-file-input__label" for="fhabitacion2">     
                                                              <input
                                                                id="fhabitacion2"
                                                                type="button" 
                                                                name="attachment" 
                                                                class="c-file-input__field js-file-input__field"
                                                                onclick="document.getElementById('habitacion2').click();" 
                                                                >
                                                            </label>
                                                <b-form-file @change="onFileChangeHabitacion2" id="habitacion2" v-model="$v.acommodation.fotos.habitacion2.$model" style="display:none;"></b-form-file>
                                            </div>
                                        </div>
                                        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3 mt-2">
    
                                            <span @click="preview.bano = false; acommodation.fotos.bano = null" v-if="acommodation.fotos.bano" class="close-pic">X</span>
    
                                            <div class="c-file-input js-file-input">
                                                <div class="c-file-input__indicator">
                                                    <img src="../assets/baño.svg">
                                                    <img v-show="preview.bano" style="width: 160%; position:relative; margin-top:-100px; margin-left:-30px;" :style="{ backgroundImage: 'url(' + preview.bano + '  no-repeat center center fixed background-size: cover;)' }" :src="preview.bano" />
                                                    <div v-if="iso639_1 === 'es'">
                                                        Agrega foto Baño
                                                    </div>
                                                    <div v-else>
                                                        Add photo Bathroom
                                                    </div>
                                                    <p style="margin-left:-5px;" class="text-danger" v-if="!$v.acommodation.fotos.bano.required">Requerido</p>
                                                    <!-- <div class="col-12 cortar">
                                                              {{acommodation.fotos.bano ? acommodation.fotos.bano.name: ''}}
                                                              
                                                              </div> -->
                                                </div>
                                                <label class="c-file-input__label js-file-input__label" for="fbano">     
                                                              <input
                                                                id="fbano"
                                                                type="button" 
                                                                name="attachment" 
                                                                class="c-file-input__field js-file-input__field"
                                                                onclick="document.getElementById('bano').click();" 
                                                                >
                                                            </label>
                                                <b-form-file @change="onFileChangeBano" id="bano" v-model="$v.acommodation.fotos.bano.$model" style="display:none;"></b-form-file>
                                            </div>
                                        </div>
                                        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3 mt-2">
    
                                            <span @click="preview.cocina = false; acommodation.fotos.cocina1 = null" v-if="acommodation.fotos.cocina1" class="close-pic">X</span>
    
                                            <div class="c-file-input js-file-input">
                                                <div class="c-file-input__indicator">
                                                    <img src="../assets/cocina2.svg">
                                                    <img v-show="preview.cocina" style="width: 160%; position:relative; margin-top:-100px; margin-left:-30px;" :style="{ backgroundImage: 'url(' + preview.cocina + '  no-repeat center center fixed background-size: cover;)' }" :src="preview.cocina" />
                                                    <div v-if="iso639_1 === 'es'">
                                                        Agrega foto Cocina
                                                    </div>
                                                    <div v-else>
                                                        Add photo Kitchen
                                                    </div>
                                                    <!-- <div class="col-12 cortar">
                                                              {{acommodation.fotos.cocina1 ? acommodation.fotos.cocina1.name: ''}}
                                                               
                                                              </div> -->
                                                    <p style="margin-left:-5px;" class="text-danger" v-if="!$v.acommodation.fotos.cocina1.required">Requerido</p>
                                                </div>
                                                <label class="c-file-input__label js-file-input__label" for="fcocina">     
                                                              <input
                                                                id="fcocina"
                                                                type="button" 
                                                                name="attachment" 
                                                                class="c-file-input__field js-file-input__field"
                                                                onclick="document.getElementById('cocina').click();" 
                                                                >
                                                            </label>
                                                <b-form-file @change="onFileChangeCocina" id="cocina" v-model="$v.acommodation.fotos.cocina1.$model" style="display:none;"></b-form-file>
                                            </div>
                                        </div>
                                        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3 mt-2">
    
                                            <span @click="preview.cocina2 = false; acommodation.fotos.cocina2 = null" v-if="acommodation.fotos.cocina2" class="close-pic">X</span>
    
                                            <div class="c-file-input js-file-input">
                                                <div class="c-file-input__indicator">
                                                    <img src="../assets/cocina2.svg">
                                                    <img v-show="preview.cocina2" style="width: 160%; position:relative; margin-top:-100px; margin-left:-30px;" :style="{ backgroundImage: 'url(' + preview.cocina2 + '  no-repeat center center fixed background-size: cover;)' }" :src="preview.cocina2" />
                                                    <div v-if="iso639_1 === 'es'">
                                                        Agrega foto Cocina
                                                    </div>
                                                    <div v-else>
                                                        Add photo Kitchen
                                                    </div>
                                                    <p style="margin-left:-5px;" class="text-danger" v-if="!$v.acommodation.fotos.cocina2.required">Requerido</p>
                                                    <!-- <div class="col-12 cortar">
                                                              {{acommodation.fotos.cocina2 ? acommodation.fotos.cocina2.name: ''}}
                                                              
                                                              </div> -->
                                                </div>
                                                <label class="c-file-input__label js-file-input__label" for="fcocina2">     
                                                              <input
                                                                id="fcocina2"
                                                                type="button" 
                                                                name="attachment" 
                                                                class="c-file-input__field js-file-input__field"
                                                                onclick="document.getElementById('cocina2').click();" 
                                                                >
                                                            </label>
                                                <b-form-file @change="onFileChangeCocina2" id="cocina2" v-model="$v.acommodation.fotos.cocina2.$model" style="display:none;"></b-form-file>
                                            </div>
                                        </div>
                                        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3 mt-2">
    
                                            <span @click="preview.living = false; acommodation.fotos.living = null" v-if="acommodation.fotos.living" class="close-pic">X</span>
    
                                            <div class="c-file-input js-file-input">
                                                <div class="c-file-input__indicator">
                                                    <img src="../assets/living.svg">
                                                    <img v-show="preview.living" style="width: 160%; position:relative; margin-top:-100px; margin-left:-30px;" :style="{ backgroundImage: 'url(' + preview.living + '  no-repeat center center fixed background-size: cover;)' }" :src="preview.living" />
                                                    <div v-if="iso639_1 === 'es'">
                                                        Agrega foto Living
                                                    </div>
                                                    <div v-else>
                                                        Add photo Living
                                                    </div>
                                                    <!-- <div class="col-12 cortar">
                                                              {{acommodation.fotos.living ? acommodation.fotos.living.name: ''}}
                                                              
                                                              </div> -->
                                                    <p style="margin-left:-5px;" class="text-danger" v-if="!$v.acommodation.fotos.living.required">Requerido</p>
                                                </div>
                                                <label class="c-file-input__label js-file-input__label" for="fliving">     
                                                              <input
                                                                id="fliving"
                                                                type="button" 
                                                                name="attachment" 
                                                                class="c-file-input__field js-file-input__field"
                                                                onclick="document.getElementById('living').click();" 
                                                                >
                                                            </label>
                                                <b-form-file @change="onFileChangeLiving" id="living" v-model="$v.acommodation.fotos.living.$model" style="display:none;"></b-form-file>
                                            </div>
                                        </div>
                                        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3 mt-2">
    
                                            <span @click="preview.comedor = false; acommodation.fotos.comedor = null" v-if="acommodation.fotos.comedor" class="close-pic">X</span>
    
                                            <div class="c-file-input js-file-input">
                                                <div class="c-file-input__indicator">
                                                    <img src="../assets/comedor.svg">
                                                    <img v-show="preview.comedor" style="width: 160%; position:relative; margin-top:-100px; margin-left:-30px;" :style="{ backgroundImage: 'url(' + preview.comedor + '  no-repeat center center fixed background-size: cover;)' }" :src="preview.comedor" />
                                                    <div v-if="iso639_1 === 'es'">
                                                        Agrega foto Comedor
                                                    </div>
                                                    <div v-else>
                                                        Add photo Dining
                                                    </div>
                                                    <p style="margin-left:-5px;" class="text-danger" v-if="!$v.acommodation.fotos.comedor.required">Requerido</p>
                                                    <!-- <div class="col-12 cortar">
                                                              {{acommodation.fotos.comedor ? acommodation.fotos.comedor.name: ''}}
                                                              
                                                              </div> -->
                                                </div>
                                                <label class="c-file-input__label js-file-input__label" for="fcomedor">     
                                                              <input
                                                                id="fcomedor"
                                                                type="button" 
                                                                name="attachment" 
                                                                class="c-file-input__field js-file-input__field"
                                                                onclick="document.getElementById('comedor').click();" 
                                                                >
                                                            </label>
                                                <b-form-file @change="onFileChangeComedor" id="comedor" v-model="$v.acommodation.fotos.comedor.$model" style="display:none;"></b-form-file>
                                            </div>
                                        </div>
                                        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3 mt-2">
    
                                            <span @click="preview.otro = false; acommodation.fotos.otro = null" v-if="acommodation.fotos.otro" class="close-pic">X</span>
                                            <div class="c-file-input js-file-input">
                                                <div class="c-file-input__indicator">
                                                    <img src="../assets/mas.svg">
                                                    <img v-show="preview.otro" style="width: 160%; position:relative; margin-top:-100px; margin-left:-30px;" :style="{ backgroundImage: 'url(' + preview.otro + '  no-repeat center center fixed background-size: cover;)' }" :src="preview.otro" />
                                                    <div v-if="iso639_1 === 'es'">
                                                        Agrega más fotos!
                                                    </div>
                                                    <div v-else>
                                                        Add more photos!
                                                    </div>
                                                    <!-- <div class="col-12 cortar">
                                                              {{acommodation.fotos.otro ? acommodation.fotos.otro.name: ''}}
                                                              
                                                              </div> -->
                                                    <p style="margin-left:-5px;" class="text-danger" v-if="!$v.acommodation.fotos.otro.required">Requerido</p>
                                                </div>
                                                <label class="c-file-input__label js-file-input__label" for="fotro">     
                                                              <input
                                                                id="fotro"
                                                                type="button" 
                                                                name="attachment" 
                                                                class="c-file-input__field js-file-input__field"
                                                                onclick="document.getElementById('otro').click();" 
                                                                >
                                                            </label>
                                                <b-form-file @change="onFileChangeOtro" id="otro" v-model="$v.acommodation.fotos.otro.$model" style="display:none;"></b-form-file>
                                            </div>
                                        </div>
                                    </div>
    
                                    <!--fin paso 3-->
                                </tab-content>
    
                                <tab-content title="Paso 4">
                                    <!--inicio paso 4-->
    
                                    <div class="row mt-4 mb-4 morado height50 hidden-xs">
                                        <div class="avance-wrap mt-2 ">
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">1</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">2</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">3</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo activo">
                                                <h4 class="h4-numero">4</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">5</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">6</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">7</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">8</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">9</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                        </div>
                                    </div>
    
    
                                    <p v-if="iso639_1 === 'es'">
                                        Sigue los pasos para subir tu propiedad:
                                    </p>
                                    <p v-else>
                                        Follow the steps to upload your property:
                                    </p>
    
                                    <hr class="custom-100 mb-3">
    
                                    <b-card-group deck class="text-center">
                                        <b-card no-body style="max-height: 200px;" class="overflow-hidden opt-active">
                                            <b-row no-gutters>
                                                <b-col md="4" class="text-center mt-4 pl-3">
                                                    <img width="50px" src="../assets/001-rent.svg">
                                                </b-col>
                                                <b-col md="8">
                                                    <b-card-body>
                                                        <b-card-text v-if="iso639_1 === 'es'" class="mt-1" style="font-size: 10px; font-weight: bold;">
                                                            Características de la casa o departamento
                                                        </b-card-text>
                                                        <b-card-text v-else class="mt-1" style="font-size: 10px; font-weight: bold;">
                                                            Characteristics of the house or apartment
                                                        </b-card-text>
                                                    </b-card-body>
                                                </b-col>
                                            </b-row>
                                        </b-card>
    
                                        <b-card no-body style="max-height: 200px;" class="overflow-hidden">
                                            <b-row no-gutters>
                                                <b-col md="4" class="text-center mt-4 pl-3">
                                                    <img width="50px" src="../assets/002-room.svg">
                                                </b-col>
                                                <b-col md="8">
                                                    <b-card-body>
                                                        <b-card-text v-if="iso639_1 === 'es'" class="mt-2" style="font-size: 10px; font-weight: bold;">
                                                            Características de la habitación
                                                        </b-card-text>
                                                        <b-card-text v-else class="mt-2" style="font-size: 12px; font-weight: bold;">
                                                            Room features
                                                        </b-card-text>
                                                    </b-card-body>
                                                </b-col>
                                            </b-row>
                                        </b-card>
    
                                        <b-card no-body class="overflow-hidden">
                                            <b-row no-gutters>
                                                <b-col md="4" class="text-center mt-4 pl-3">
                                                    <img width="30px" src="../assets/pin.svg">
                                                </b-col>
                                                <b-col md="8">
                                                    <b-card-body>
                                                        <b-card-text v-if="iso639_1 === 'es'" class="mt-2" style="font-size: 10px; font-weight: bold;">
                                                            Características de la ubicación
                                                        </b-card-text>
                                                        <b-card-text v-else class="mt-2" style="font-size: 12px; font-weight: bold;">
                                                            Location Features
                                                        </b-card-text>
                                                    </b-card-body>
                                                </b-col>
                                            </b-row>
                                        </b-card>
    
                                        <b-card no-body class="overflow-hidden">
                                            <b-row no-gutters>
                                                <b-col md="4" class="text-center mt-4 pl-3">
                                                    <img width="50px" src="../assets/family.svg">
                                                </b-col>
                                                <b-col md="8">
                                                    <b-card-body>
                                                        <b-card-text v-if="iso639_1 === 'es'" class="mt-3" style="font-size: 11px; font-weight: bold;">
                                                            Sobre nosotros
                                                        </b-card-text>
                                                        <b-card-text v-else class="mt-3" style="font-size: 12px; font-weight: bold;">
                                                            About us
                                                        </b-card-text>
                                                    </b-card-body>
                                                </b-col>
                                            </b-row>
                                        </b-card>
    
                                    </b-card-group>
                                    <hr class="custom-100 mb-4 mt-4">
    
                                    <b-container fluid style="font-weight: bold;">
                                        <b-row>
                                            <b-col md="3 mb-4">
                                                <b-row>
                                                    <b-col cols="3" md="3" sm="3"><img width="30px" src="../assets/conserje.svg"></b-col>
                                                    <b-col v-if="iso639_1 === 'es'" cols="6" md="6" sm="6">Conserje</b-col>
                                                    <b-col v-else cols="6" md="6" sm="6">Concierge</b-col>
                                                    <b-col cols="3" md="3" sm="3">
                                                        <div class="container">
                                                            <div class="round">
                                                                <input type="checkbox" id="checkbox.conserje" v-model="acommodation.caracteristicas.conserje" true-value="1" false-value="0">
                                                                <label for="checkbox.conserje"></label>
                                                            </div>
                                                        </div>
                                                    </b-col>
                                                </b-row>
                                            </b-col>
                                            <b-col md="3 mb-4">
                                                <b-row>
                                                    <b-col cols="3" md="3" sm="3"><img width="30px" src="../assets/timbre.svg"></b-col>
                                                    <b-col v-if="iso639_1 === 'es'" cols="6" md="6" sm="6">Timbre</b-col>
                                                    <b-col v-else cols="6" md="6" sm="6">Doorbell</b-col>
                                                    <b-col cols="3" md="3" sm="3">
                                                        <div class="container">
                                                            <div class="round">
                                                                <input type="checkbox" id="checkbox.timbre" v-model="acommodation.caracteristicas.timbre" true-value="1" false-value="0">
                                                                <label for="checkbox.timbre"></label>
                                                            </div>
                                                        </div>
                                                    </b-col>
                                                </b-row>
                                            </b-col>
                                            <b-col md="3 mb-4">
                                                <b-row>
                                                    <b-col cols="3" md="3" sm="3"><img width="30px" src="../assets/bodega.svg"></b-col>
                                                    <b-col v-if="iso639_1 === 'es'" cols="6" md="6" sm="6">Bodega</b-col>
                                                    <b-col v-else cols="6" md="6" sm="6">Cellar</b-col>
                                                    <b-col cols="3" md="3" sm="3">
                                                        <div class="container">
                                                            <div class="round">
                                                                <input type="checkbox" id="checkbox.bodega" v-model="acommodation.caracteristicas.bodega" true-value="1" false-value="0">
                                                                <label for="checkbox.bodega"></label>
                                                            </div>
                                                        </div>
                                                    </b-col>
                                                </b-row>
                                            </b-col>
                                            <b-col md="3 mb-4">
                                                <b-row>
                                                    <b-col cols="3" md="3" sm="3"><img width="30px" src="../assets/eprivado.svg"></b-col>
                                                    <b-col v-if="iso639_1 === 'es'" cols="6" md="6" sm="6">Estacionamiento privado</b-col>
                                                    <b-col v-else cols="6" md="6" sm="6">Private parking</b-col>
                                                    <b-col cols="3" md="3" sm="3">
                                                        <div class="container">
                                                            <div class="round">
                                                                <input type="checkbox" id="checkbox.eprivado" v-model="acommodation.caracteristicas.eprivado" true-value="1" false-value="0">
                                                                <label for="checkbox.eprivado"></label>
                                                            </div>
                                                        </div>
                                                    </b-col>
                                                </b-row>
                                            </b-col>
                                            <b-col md="3 mb-4">
                                                <b-row>
                                                    <b-col cols="3" md="3" sm="3"><img width="30px" src="../assets/estacionamiento.svg"></b-col>
                                                    <b-col v-if="iso639_1 === 'es'" cols="6" md="6" sm="6">Estacionamiento visita</b-col>
                                                    <b-col v-else cols="6" md="6" sm="6">Parking visit</b-col>
                                                    <b-col cols="3" md="3" sm="3">
                                                        <div class="container">
                                                            <div class="round">
                                                                <input type="checkbox" id="checkbox.evisita" v-model="acommodation.caracteristicas.evisita" true-value="1" false-value="0">
                                                                <label for="checkbox.evisita"></label>
                                                            </div>
                                                        </div>
                                                    </b-col>
                                                </b-row>
                                            </b-col>
                                            <b-col md="3 mb-4">
                                                <b-row>
                                                    <b-col cols="3" md="3" sm="3"><img width="30px" src="../assets/ebicicleta.svg"></b-col>
                                                    <b-col v-if="iso639_1 === 'es'" cols="6" md="6" sm="6">Estacionamiento Bicicleta</b-col>
                                                    <b-col v-else cols="6" md="6" sm="6">Bicycle parking</b-col>
                                                    <b-col cols="3" md="3" sm="3">
                                                        <div class="container">
                                                            <div class="round">
                                                                <input type="checkbox" id="checkbox.bicicleta" v-model="acommodation.caracteristicas.ebicicleta" true-value="1" false-value="0">
                                                                <label for="checkbox.bicicleta"></label>
                                                            </div>
                                                        </div>
                                                    </b-col>
                                                </b-row>
                                            </b-col>
                                            <b-col md="3 mb-4">
                                                <b-row>
                                                    <b-col cols="3" md="3" sm="3"><img width="30px" src="../assets/sestar.svg"></b-col>
                                                    <b-col v-if="iso639_1 === 'es'" cols="6" md="6" sm="6">Sala estar</b-col>
                                                    <b-col v-else cols="6" md="6" sm="6">Living room</b-col>
                                                    <b-col cols="3" md="3" sm="3">
                                                        <div class="container">
                                                            <div class="round">
                                                                <input type="checkbox" id="checkbox.sestar" v-model="acommodation.caracteristicas.sestar" true-value="1" false-value="0">
                                                                <label for="checkbox.sestar"></label>
                                                            </div>
                                                        </div>
                                                    </b-col>
                                                </b-row>
                                            </b-col>
                                            <b-col md="3 mb-4">
                                                <b-row>
                                                    <b-col cols="3" md="3" sm="3"><img width="30px" src="../assets/seventos.svg"></b-col>
                                                    <b-col v-if="iso639_1 === 'es'" cols="6" md="6" sm="6">Salón de eventos</b-col>
                                                    <b-col v-else cols="6" md="6" sm="6">Event hall</b-col>
                                                    <b-col cols="3" md="3" sm="3">
                                                        <div class="container">
                                                            <div class="round">
                                                                <input type="checkbox" id="checkbox.seventos" v-model="acommodation.caracteristicas.seventos" true-value="1" false-value="0">
                                                                <label for="checkbox.seventos"></label>
                                                            </div>
                                                        </div>
                                                    </b-col>
                                                </b-row>
                                            </b-col>
                                            <b-col md="3 mb-4">
                                                <b-row>
                                                    <b-col cols="3" md="3" sm="3"><img width="30px" src="../assets/nature-and-relax.svg"></b-col>
                                                    <b-col v-if="iso639_1 === 'es'" cols="6" md="6" sm="6">Jardines</b-col>
                                                    <b-col v-else cols="6" md="6" sm="6">Gardens</b-col>
                                                    <b-col cols="3" md="3" sm="3">
                                                        <div class="container">
                                                            <div class="round">
                                                                <input type="checkbox" id="checkbox.jardines" v-model="acommodation.caracteristicas.jardines" true-value="1" false-value="0">
                                                                <label for="checkbox.jardines"></label>
                                                            </div>
                                                        </div>
                                                    </b-col>
                                                </b-row>
                                            </b-col>
                                            <b-col md="3 mb-4">
                                                <b-row>
                                                    <b-col cols="3" md="3" sm="3"><img width="30px" src="../assets/piscina.svg"></b-col>
                                                    <b-col v-if="iso639_1 === 'es'" cols="6" md="6" sm="6">Piscina</b-col>
                                                    <b-col v-else cols="6" md="6" sm="6">Swimming pool</b-col>
                                                    <b-col cols="3" md="3" sm="3">
                                                        <div class="container">
                                                            <div class="round">
                                                                <input type="checkbox" id="checkbox.piscina" v-model="acommodation.caracteristicas.piscina" true-value="1" false-value="0">
                                                                <label for="checkbox.piscina"></label>
                                                            </div>
                                                        </div>
                                                    </b-col>
                                                </b-row>
                                            </b-col>
                                            <b-col md="3 mb-4">
                                                <b-row>
                                                    <b-col cols="3" md="3" sm="3"><img width="30px" src="../assets/gimnasio.svg"></b-col>
                                                    <b-col v-if="iso639_1 === 'es'" cols="6" md="6" sm="6">Gimnasio</b-col>
                                                    <b-col v-else cols="6" md="6" sm="6">Fitness center</b-col>
                                                    <b-col cols="3" md="3" sm="3">
                                                        <div class="container">
                                                            <div class="round">
                                                                <input type="checkbox" id="checkbox.gimnasio" v-model="acommodation.caracteristicas.gimnasio" true-value="1" false-value="0">
                                                                <label for="checkbox.gimnasio"></label>
                                                            </div>
                                                        </div>
                                                    </b-col>
                                                </b-row>
                                            </b-col>
                                            <b-col md="3 mb-4">
                                                <b-row>
                                                    <b-col cols="3" md="3" sm="3"><img width="30px" src="../assets/desayuno.svg"></b-col>
                                                    <b-col v-if="iso639_1 === 'es'" cols="6" md="6" sm="6">Desayuno</b-col>
                                                    <b-col v-else cols="6" md="6" sm="6">Breakfast</b-col>
                                                    <b-col cols="3" md="3" sm="3">
                                                        <div class="container">
                                                            <div class="round">
                                                                <input type="checkbox" id="checkbox.desayuno" v-model="acommodation.caracteristicas.desayuno" true-value="1" false-value="0">
                                                                <label for="checkbox.desayuno"></label>
                                                            </div>
                                                        </div>
                                                    </b-col>
                                                </b-row>
                                            </b-col>
                                            <b-col md="3 mb-4">
                                                <b-row>
                                                    <b-col cols="3" md="3" sm="3"><img width="30px" src="../assets/refrigerator.svg"></b-col>
                                                    <b-col v-if="iso639_1 === 'es'" cols="6" md="6" sm="6">Refrigerador</b-col>
                                                    <b-col v-else cols="6" md="6" sm="6">Fridge</b-col>
                                                    <b-col cols="3" md="3" sm="3">
                                                        <div class="container">
                                                            <div class="round">
                                                                <input type="checkbox" id="checkbox.refrigerador" v-model="acommodation.caracteristicas.refrigerador" true-value="1" false-value="0">
                                                                <label for="checkbox.refrigerador"></label>
                                                            </div>
                                                        </div>
                                                    </b-col>
                                                </b-row>
                                            </b-col>
                                            <b-col md="3 mb-4">
                                                <b-row>
                                                    <b-col cols="3" md="3" sm="3"><img width="30px" src="../assets/cocina.svg"></b-col>
                                                    <b-col v-if="iso639_1 === 'es'" cols="6" md="6" sm="6">Cocina</b-col>
                                                    <b-col v-else cols="6" md="6" sm="6">Kitchen</b-col>
                                                    <b-col cols="3" md="3" sm="3">
                                                        <div class="container">
                                                            <div class="round">
                                                                <input type="checkbox" id="checkbox.cocina" v-model="acommodation.caracteristicas.cocina" true-value="1" false-value="0">
                                                                <label for="checkbox.cocina"></label>
                                                            </div>
                                                        </div>
                                                    </b-col>
                                                </b-row>
                                            </b-col>
                                            <b-col md="3 mb-4">
                                                <b-row>
                                                    <b-col cols="3" md="3" sm="3"><img width="30px" src="../assets/microondas.svg"></b-col>
                                                    <b-col v-if="iso639_1 === 'es'" cols="6" md="6" sm="6">Microondas</b-col>
                                                    <b-col v-else cols="6" md="6" sm="6">Microwave oven</b-col>
                                                    <b-col cols="3" md="3" sm="3">
                                                        <div class="container">
                                                            <div class="round">
                                                                <input type="checkbox" id="checkbox.microondas" v-model="acommodation.caracteristicas.microondas" true-value="1" false-value="0">
                                                                <label for="checkbox.microondas"></label>
                                                            </div>
                                                        </div>
                                                    </b-col>
                                                </b-row>
                                            </b-col>
                                            <b-col md="3 mb-4">
                                                <b-row>
                                                    <b-col cols="3" md="3" sm="3"><img width="30px" src="../assets/parrilla.svg"></b-col>
                                                    <b-col v-if="iso639_1 === 'es'" cols="6" md="6" sm="6">Parrilla</b-col>
                                                    <b-col v-else cols="6" md="6" sm="6">Grill</b-col>
                                                    <b-col cols="3" md="3" sm="3">
                                                        <div class="container">
                                                            <div class="round">
                                                                <input type="checkbox" id="checkbox.parrilla" v-model="acommodation.caracteristicas.parrilla" true-value="1" false-value="0">
                                                                <label for="checkbox.parrilla"></label>
                                                            </div>
                                                        </div>
                                                    </b-col>
                                                </b-row>
                                            </b-col>
                                            <b-col md="3 mb-4">
                                                <b-row>
                                                    <b-col cols="3" md="3" sm="3"><img width="30px" src="../assets/horno.svg"></b-col>
                                                    <b-col v-if="iso639_1 === 'es'" cols="6" md="6" sm="6">Horno</b-col>
                                                    <b-col v-else cols="6" md="6" sm="6">Oven</b-col>
                                                    <b-col cols="3" md="3" sm="3">
                                                        <div class="container">
                                                            <div class="round">
                                                                <input type="checkbox" id="checkbox.horno" v-model="acommodation.caracteristicas.horno" true-value="1" false-value="0">
                                                                <label for="checkbox.horno"></label>
                                                            </div>
                                                        </div>
                                                    </b-col>
                                                </b-row>
                                            </b-col>
                                            <b-col md="3 mb-4">
                                                <b-row>
                                                    <b-col cols="3" md="3" sm="3"><img width="30px" src="../assets/lavadora.svg"></b-col>
                                                    <b-col v-if="iso639_1 === 'es'" cols="6" md="6" sm="6">Lavadora</b-col>
                                                    <b-col v-else cols="6" md="6" sm="6">Washing machine</b-col>
                                                    <b-col cols="3" md="3" sm="3">
                                                        <div class="container">
                                                            <div class="round">
                                                                <input type="checkbox" id="checkbox.lavadora" v-model="acommodation.caracteristicas.lavadora" true-value="1" false-value="0">
                                                                <label for="checkbox.lavadora"></label>
                                                            </div>
                                                        </div>
                                                    </b-col>
                                                </b-row>
                                            </b-col>
                                            <b-col md="3 mb-4">
                                                <b-row>
                                                    <b-col cols="3" md="3" sm="3"><img width="30px" src="../assets/secadora.svg"></b-col>
                                                    <b-col v-if="iso639_1 === 'es'" cols="6" md="6" sm="6">Secadora</b-col>
                                                    <b-col v-else cols="6" md="6" sm="6">Dryer</b-col>
                                                    <b-col cols="3" md="3" sm="3">
                                                        <div class="container">
                                                            <div class="round">
                                                                <input type="checkbox" id="checkbox.secadora" v-model="acommodation.caracteristicas.secadora" true-value="1" false-value="0">
                                                                <label for="checkbox.secadora"></label>
                                                            </div>
                                                        </div>
                                                    </b-col>
                                                </b-row>
                                            </b-col>
                                            <b-col md="3 mb-4">
                                                <b-row>
                                                    <b-col cols="3" md="3" sm="3"><img width="30px" src="../assets/plancha.svg"></b-col>
                                                    <b-col v-if="iso639_1 === 'es'" cols="6" md="6" sm="6">Plancha</b-col>
                                                    <b-col v-else cols="6" md="6" sm="6">Griddle</b-col>
                                                    <b-col cols="3" md="3" sm="3">
                                                        <div class="container">
                                                            <div class="round">
                                                                <input type="checkbox" id="checkbox.plancha" v-model="acommodation.caracteristicas.plancha" true-value="1" false-value="0">
                                                                <label for="checkbox.plancha"></label>
                                                            </div>
                                                        </div>
                                                    </b-col>
                                                </b-row>
                                            </b-col>
                                            <b-col md="3 mb-4">
                                                <b-row>
                                                    <b-col cols="3" md="3" sm="3"><img width="30px" src="../assets/limpieza.svg"></b-col>
                                                    <b-col v-if="iso639_1 === 'es'" cols="6" md="6" sm="6">Limpieza</b-col>
                                                    <b-col v-else cols="6" md="6" sm="6">Cleaning</b-col>
                                                    <b-col cols="3" md="3" sm="3">
                                                        <div class="container">
                                                            <div class="round">
                                                                <input type="checkbox" id="checkbox.limpieza" v-model="acommodation.caracteristicas.limpieza" true-value="1" false-value="0">
                                                                <label for="checkbox.limpieza"></label>
                                                            </div>
                                                        </div>
                                                    </b-col>
                                                </b-row>
                                            </b-col>
                                            <b-col md="3 mb-4">
                                                <b-row>
                                                    <b-col cols="3" md="3" sm="3"><img width="30px" src="../assets/mascotas.svg"></b-col>
                                                    <b-col v-if="iso639_1 === 'es'" cols="6" md="6" sm="6">Mascotas</b-col>
                                                    <b-col v-else cols="6" md="6" sm="6">Pets</b-col>
                                                    <b-col cols="3" md="3" sm="3">
                                                        <div class="container">
                                                            <div class="round">
                                                                <input type="checkbox" id="checkbox.mascotas" v-model="acommodation.caracteristicas.mascotas" true-value="1" false-value="0">
                                                                <label for="checkbox.mascotas"></label>
                                                            </div>
                                                        </div>
                                                    </b-col>
                                                </b-row>
                                            </b-col>
                                        </b-row>
                                    </b-container>
    
                                    <!--fin paso 4-->
                                </tab-content>
    
                                <tab-content title="Paso 5">
    
                                    <div class="row mt-4 mb-4 morado height50 hidden-xs">
                                        <div class="avance-wrap mt-2 ">
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">1</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">2</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">3</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">4</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo activo">
                                                <h4 class="h4-numero">5</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">6</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">7</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">8</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">9</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <!--inicio paso 5-->
                                    <p v-if="iso639_1 === 'es'">
                                        Sigue los pasos para subir tu propiedad:
                                    </p>
                                    <p v-else>
                                        Follow the steps to upload your property:
                                    </p>
                                    <hr class="custom-100 mb-3">
    
                                    <b-card-group deck class="text-center">
                                        <b-card no-body style="max-height: 200px;" class="overflow-hidden">
                                            <b-row no-gutters>
                                                <b-col md="4" class="text-center mt-4 pl-3">
                                                    <img width="50px" src="../assets/001-rent.svg">
                                                </b-col>
                                                <b-col md="8">
                                                    <b-card-body>
                                                        <b-card-text v-if="iso639_1 === 'es'" class="mt-1" style="font-size: 10px; font-weight: bold;">
                                                            Características de la casa o departamento
                                                        </b-card-text>
                                                        <b-card-text v-else class="mt-1" style="font-size: 10px; font-weight: bold;">
                                                            Characteristics of the house or apartment
                                                        </b-card-text>
                                                    </b-card-body>
                                                </b-col>
                                            </b-row>
                                        </b-card>
    
                                        <b-card no-body style="max-height: 200px;" class="overflow-hidden opt-active">
                                            <b-row no-gutters>
                                                <b-col md="4" class="text-center mt-4 pl-3">
                                                    <img width="50px" src="../assets/002-room.svg">
                                                </b-col>
                                                <b-col md="8">
                                                    <b-card-body>
                                                        <b-card-text v-if="iso639_1 === 'es'" class="mt-2" style="font-size: 10px; font-weight: bold;">
                                                            Características de la habitación
                                                            <button style="background:none; width:38px; height:35px; border:none;" class="form-control ml-4 " v-if="entero" @click="duplicate">
                                                                      <font-awesome-icon  :style="{ color: 'white'}" size="1x" :icon="['fa', 'plus']" />                           
                                                                     </button>
                                                        </b-card-text>
                                                        <b-card-text v-else class="mt-2" style="font-size: 12px; font-weight: bold;">
                                                            Room features
                                                            <button style="background:none; width:38px; height:35px; border:none;" class="form-control ml-4 " v-if="entero" @click="duplicate">
                                                                      <font-awesome-icon  :style="{ color: 'white'}" size="1x" :icon="['fa', 'plus']" />                           
                                                                     </button>
                                                        </b-card-text>
                                                    </b-card-body>
                                                </b-col>
                                            </b-row>
                                        </b-card>
    
                                        <b-card no-body class="overflow-hidden">
                                            <b-row no-gutters>
                                                <b-col md="4" class="text-center mt-4 pl-3">
                                                    <img width="30px" src="../assets/pin.svg">
                                                </b-col>
                                                <b-col md="8">
                                                    <b-card-body>
                                                        <b-card-text v-if="iso639_1 === 'es'" class="mt-2" style="font-size: 10px; font-weight: bold;">
                                                            Características de la ubicación
                                                        </b-card-text>
                                                        <b-card-text v-else class="mt-2" style="font-size: 12px; font-weight: bold;">
                                                            Location Features
                                                        </b-card-text>
                                                    </b-card-body>
                                                </b-col>
                                            </b-row>
                                        </b-card>
    
                                        <b-card no-body class="overflow-hidden">
                                            <b-row no-gutters>
                                                <b-col md="4" class="text-center mt-4 pl-3">
                                                    <img width="50px" src="../assets/family.svg">
                                                </b-col>
                                                <b-col md="8">
                                                    <b-card-body>
                                                        <b-card-text v-if="iso639_1 === 'es'" class="mt-3" style="font-size: 11px; font-weight: bold;">
                                                            Sobre nosotros
                                                        </b-card-text>
                                                        <b-card-text v-else class="mt-3" style="font-size: 12px; font-weight: bold;">
                                                            About us
                                                        </b-card-text>
                                                    </b-card-body>
                                                </b-col>
                                            </b-row>
                                        </b-card>
    
                                    </b-card-group>
                                    <hr class="custom-100 mb-4 mt-4">
    
                                    <div role="tablist">
                                        <div ref="container">
                                        </div>
                                    </div>
    
    
                                    <!--fin paso 5-->
                                </tab-content>
    
    
                                <tab-content title="Paso 6">
                                    <!--inicio paso 6-->
    
                                    <div class="row mt-4 mb-4 morado height50 hidden-xs">
                                        <div class="avance-wrap mt-2 ">
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">1</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">2</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">3</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">4</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">5</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo activo">
                                                <h4 class="h4-numero">6</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">7</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">8</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">9</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <p v-if="iso639_1 === 'es'">
                                        Sigue los pasos para subir tu propiedad:
                                    </p>
                                    <p v-else>
                                        Follow the steps to upload your property:
                                    </p>
                                    <hr class="custom-100 mb-3">
    
                                    <b-card-group deck class="text-center">
                                        <b-card no-body style="max-height: 200px;" class="overflow-hidden">
                                            <b-row no-gutters>
                                                <b-col md="4" class="text-center mt-4 pl-3">
                                                    <img width="50px" src="../assets/001-rent.svg">
                                                </b-col>
                                                <b-col md="8">
                                                    <b-card-body>
                                                        <b-card-text v-if="iso639_1 === 'es'" class="mt-1" style="font-size: 10px; font-weight: bold;">
                                                            Características de la casa o departamento
                                                        </b-card-text>
                                                        <b-card-text v-else class="mt-1" style="font-size: 10px; font-weight: bold;">
                                                            Characteristics of the house or apartment
                                                        </b-card-text>
                                                    </b-card-body>
                                                </b-col>
                                            </b-row>
                                        </b-card>
    
                                        <b-card no-body style="max-height: 200px;" class="overflow-hidden">
                                            <b-row no-gutters>
                                                <b-col md="4" class="text-center mt-4 pl-3">
                                                    <img width="50px" src="../assets/002-room.svg">
                                                </b-col>
                                                <b-col md="8">
                                                    <b-card-body>
                                                        <b-card-text v-if="iso639_1 === 'es'" class="mt-2" style="font-size: 10px; font-weight: bold;">
                                                            Características de la habitación
                                                        </b-card-text>
                                                        <b-card-text v-else class="mt-2" style="font-size: 12px; font-weight: bold;">
                                                            Room features
                                                            <button style="background:none; width:38px; height:35px; border:none;" class="form-control ml-4 " v-if="entero" @click="duplicate">
                                                                      <font-awesome-icon  :style="{ color: 'white'}" size="1x" :icon="['fa', 'plus']" />                           
                                                                     </button>
                                                        </b-card-text>
                                                    </b-card-body>
                                                </b-col>
                                            </b-row>
                                        </b-card>
    
                                        <b-card no-body class="overflow-hidden opt-active">
                                            <b-row no-gutters>
                                                <b-col md="4" class="text-center mt-4 pl-3">
                                                    <img width="30px" src="../assets/pin.svg">
                                                </b-col>
                                                <b-col md="8">
                                                    <b-card-body>
                                                        <b-card-text v-if="iso639_1 === 'es'" class="mt-2" style="font-size: 10px; font-weight: bold;">
                                                            Características de la ubicación
                                                        </b-card-text>
                                                        <b-card-text v-else class="mt-2" style="font-size: 12px; font-weight: bold;">
                                                            Location Features
                                                        </b-card-text>
                                                    </b-card-body>
                                                </b-col>
                                            </b-row>
                                        </b-card>
    
                                        <b-card no-body class="overflow-hidden">
                                            <b-row no-gutters>
                                                <b-col md="4" class="text-center mt-4 pl-3">
                                                    <img width="50px" src="../assets/family.svg">
                                                </b-col>
                                                <b-col md="8">
                                                    <b-card-body>
                                                        <b-card-text v-if="iso639_1 === 'es'" class="mt-3" style="font-size: 11px; font-weight: bold;">
                                                            Sobre nosotros
                                                        </b-card-text>
                                                        <b-card-text v-else class="mt-3" style="font-size: 12px; font-weight: bold;">
                                                            About us
                                                        </b-card-text>
                                                    </b-card-body>
                                                </b-col>
                                            </b-row>
                                        </b-card>
    
                                    </b-card-group>
                                    <hr class="custom-100 mb-4 mt-4">
    
                                    <b-container fluid style="font-weight: bold;">
                                        <b-row>
                                            <b-col md="3 mb-4">
                                                <b-row>
                                                    <b-col cols="3" md="3" sm="3"><img width="30px" src="../assets/estacion-metro.svg"></b-col>
                                                    <b-col v-if="iso639_1 === 'es'" cols="6" md="6" sm="6">Estación de metro</b-col>
                                                    <b-col v-else cols="6" md="6" sm="6">Metro station</b-col>
                                                    <b-col cols="3" md="3" sm="3">
                                                        <div class="container">
                                                            <div class="round">
                                                                <input type="checkbox" id="checkbox.metro" v-model="acommodation.caracteristicas.metro" true-value="1" false-value="0">
                                                                <label for="checkbox.metro"></label>
                                                            </div>
                                                        </div>
                                                    </b-col>
                                                </b-row>
                                            </b-col>
                                            <b-col md="3 mb-4">
                                                <b-row>
                                                    <b-col cols="3" md="3" sm="3"><img width="30px" src="../assets/paradero-buses.svg"></b-col>
                                                    <b-col v-if="iso639_1 === 'es'" cols="6" md="6" sm="6">Paradero de micro</b-col>
                                                    <b-col v-else cols="6" md="6" sm="6">Whereabouts of micro</b-col>
                                                    <b-col cols="3" md="3" sm="3">
                                                        <div class="container">
                                                            <div class="round">
                                                                <input type="checkbox" id="checkbox.paradero" v-model="acommodation.caracteristicas.paradero" true-value="1" false-value="0">
                                                                <label for="checkbox.paradero"></label>
                                                            </div>
                                                        </div>
                                                    </b-col>
                                                </b-row>
                                            </b-col>
                                            <b-col md="3 mb-4">
                                                <b-row>
                                                    <b-col cols="3" md="3" sm="3"><img width="30px" src="../assets/hospital.svg"></b-col>
                                                    <b-col v-if="iso639_1 === 'es'" cols="6" md="6" sm="6">Centro de salud</b-col>
                                                    <b-col v-else cols="6" md="6" sm="6">Clinic</b-col>
                                                    <b-col cols="3" md="3" sm="3">
                                                        <div class="container">
                                                            <div class="round">
                                                                <input type="checkbox" id="checkbox.csalud" v-model="acommodation.caracteristicas.csalud" true-value="1" false-value="0">
                                                                <label for="checkbox.csalud"></label>
                                                            </div>
                                                        </div>
                                                    </b-col>
                                                </b-row>
                                            </b-col>
                                            <b-col md="3 mb-4">
                                                <b-row>
                                                    <b-col cols="3" md="3" sm="3"><img width="30px" src="../assets/supermercado.svg"></b-col>
                                                    <b-col v-if="iso639_1 === 'es'" cols="6" md="6" sm="6">Supermercado</b-col>
                                                    <b-col v-else cols="6" md="6" sm="6">Supermarket</b-col>
                                                    <b-col cols="3" md="3" sm="3">
                                                        <div class="container">
                                                            <div class="round">
                                                                <input type="checkbox" id="checkbox.supermercado" v-model="acommodation.caracteristicas.supermercado" true-value="1" false-value="0">
                                                                <label for="checkbox.supermercado"></label>
                                                            </div>
                                                        </div>
                                                    </b-col>
                                                </b-row>
                                            </b-col>
                                            <b-col md="3 mb-4">
                                                <b-row>
                                                    <b-col cols="3" md="3" sm="3"><img width="30px" src="../assets/banco.svg"></b-col>
                                                    <b-col v-if="iso639_1 === 'es'" cols="6" md="6" sm="6">Banco</b-col>
                                                    <b-col v-else cols="6" md="6" sm="6">Bank</b-col>
                                                    <b-col cols="3" md="3" sm="3">
                                                        <div class="container">
                                                            <div class="round">
                                                                <input type="checkbox" id="checkbox.banco" v-model="acommodation.caracteristicas.banco" true-value="1" false-value="0">
                                                                <label for="checkbox.banco"></label>
                                                            </div>
                                                        </div>
                                                    </b-col>
                                                </b-row>
                                            </b-col>
                                            <b-col md="3 mb-4">
                                                <b-row>
                                                    <b-col cols="3" md="3" sm="3"><img width="30px" src="../assets/zona-nocturna.svg"></b-col>
                                                    <b-col v-if="iso639_1 === 'es'" cols="6" md="6" sm="6">Zona nocturna</b-col>
                                                    <b-col v-else cols="6" md="6" sm="6">Night zone</b-col>
                                                    <b-col cols="3" md="3" sm="3">
                                                        <div class="container">
                                                            <div class="round">
                                                                <input type="checkbox" id="checkbox.znocturna" v-model="acommodation.caracteristicas.znocturna" true-value="1" false-value="0">
                                                                <label for="checkbox.znocturna"></label>
                                                            </div>
                                                        </div>
                                                    </b-col>
                                                </b-row>
                                            </b-col>
                                            <b-col md="3 mb-4">
                                                <b-row>
                                                    <b-col cols="3" md="3" sm="3"><img width="30px" src="../assets/areas-verdes.svg"></b-col>
                                                    <b-col v-if="iso639_1 === 'es'" cols="6" md="6" sm="6">Áreas verdes</b-col>
                                                    <b-col v-else cols="6" md="6" sm="6">Green areas</b-col>
                                                    <b-col cols="3" md="3" sm="3">
                                                        <div class="container">
                                                            <div class="round">
                                                                <input type="checkbox" id="checkbox.averdes" v-model="acommodation.caracteristicas.averdes" true-value="1" false-value="0">
                                                                <label for="checkbox.averdes"></label>
                                                            </div>
                                                        </div>
                                                    </b-col>
                                                </b-row>
                                            </b-col>
                                            <b-col md="3 mb-4">
                                                <b-row>
                                                    <b-col cols="3" md="3" sm="3"><img width="30px" src="../assets/centro-comercial.svg"></b-col>
                                                    <b-col v-if="iso639_1 === 'es'" cols="6" md="6" sm="6">Centro comercial</b-col>
                                                    <b-col v-else cols="6" md="6" sm="6">Mall</b-col>
                                                    <b-col cols="3" md="3" sm="3">
                                                        <div class="container">
                                                            <div class="round">
                                                                <input type="checkbox" id="checkbox.comercial" v-model="acommodation.caracteristicas.comercial" true-value="1" false-value="0">
                                                                <label for="checkbox.comercial"></label>
                                                            </div>
                                                        </div>
                                                    </b-col>
                                                </b-row>
                                            </b-col>
                                            <b-col md="3 mb-4">
                                                <b-row>
                                                    <b-col cols="3" md="3" sm="3"><img width="30px" src="../assets/centro-civico.svg"></b-col>
                                                    <b-col v-if="iso639_1 === 'es'" cols="6" md="6" sm="6">Centro Cívico</b-col>
                                                    <b-col v-else cols="6" md="6" sm="6">Civic Center</b-col>
                                                    <b-col cols="3" md="3" sm="3">
                                                        <div class="container">
                                                            <div class="round">
                                                                <input type="checkbox" id="checkbox.civico" v-model="acommodation.caracteristicas.civico" true-value="1" false-value="0">
                                                                <label for="checkbox.civico"></label>
                                                            </div>
                                                        </div>
                                                    </b-col>
                                                </b-row>
                                            </b-col>
                                            <b-col md="3 mb-4">
                                                <b-row>
                                                    <b-col cols="3" md="3" sm="3"><img width="30px" src="../assets/gimnasio.svg"></b-col>
                                                    <b-col v-if="iso639_1 === 'es'" cols="6" md="6" sm="6">Gimnasio</b-col>
                                                    <b-col v-else cols="6" md="6" sm="6">Fitness center</b-col>
                                                    <b-col cols="3" md="3" sm="3">
                                                        <div class="container">
                                                            <div class="round">
                                                                <input type="checkbox" id="checkbox.gimnasioe" v-model="acommodation.caracteristicas.gimnasioe" true-value="1" false-value="0">
                                                                <label for="checkbox.gimnasioe"></label>
                                                            </div>
                                                        </div>
                                                    </b-col>
                                                </b-row>
                                            </b-col>
    
                                        </b-row>
                                    </b-container>
    
                                    <!--fin paso 6-->
                                </tab-content>
    
                                <tab-content title="Paso 7">
                                    <!--inicio paso 7-->
    
                                    <div class="row mt-4 mb-4 morado height50 hidden-xs">
                                        <div class="avance-wrap mt-2">
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">1</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">2</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">3</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">4</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">5</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">6</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo activo">
                                                <h4 class="h4-numero">7</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">8</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">9</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <p v-if="iso639_1 === 'es'">
                                        Sigue los pasos para subir tu propiedad:
                                    </p>
                                    <p v-else>
                                        Follow the steps to upload your property:
                                    </p>
                                    <hr class="custom-100 mb-3">
    
                                    <b-card-group deck class="text-center">
                                        <b-card no-body style="max-height: 200px;" class="overflow-hidden">
                                            <b-row no-gutters>
                                                <b-col md="4" class="text-center mt-4 pl-3">
                                                    <img width="50px" src="../assets/001-rent.svg">
                                                </b-col>
                                                <b-col md="8">
                                                    <b-card-body>
                                                        <b-card-text v-if="iso639_1 === 'es'" class="mt-1" style="font-size: 10px; font-weight: bold;">
                                                            Características de la casa o departamento
                                                        </b-card-text>
                                                        <b-card-text v-else class="mt-1" style="font-size: 10px; font-weight: bold;">
                                                            Characteristics of the house or apartment
                                                        </b-card-text>
                                                    </b-card-body>
                                                </b-col>
                                            </b-row>
                                        </b-card>
    
                                        <b-card no-body style="max-height: 200px;" class="overflow-hidden">
                                            <b-row no-gutters>
                                                <b-col md="4" class="text-center mt-4 pl-3">
                                                    <img width="50px" src="../assets/002-room.svg">
                                                </b-col>
                                                <b-col md="8">
                                                    <b-card-body>
                                                        <b-card-text v-if="iso639_1 === 'es'" class="mt-2" style="font-size: 10px; font-weight: bold;">
                                                            Características de la habitación
                                                        </b-card-text>
                                                        <b-card-text v-else class="mt-2" style="font-size: 12px; font-weight: bold;">
                                                            Room features
                                                            <button style="background:none; width:38px; height:35px; border:none;" class="form-control ml-4 " v-if="entero" @click="duplicate">
                                                                      <font-awesome-icon  :style="{ color: 'white'}" size="1x" :icon="['fa', 'plus']" />                           
                                                                     </button>
                                                        </b-card-text>
                                                    </b-card-body>
                                                </b-col>
                                            </b-row>
                                        </b-card>
    
                                        <b-card no-body class="overflow-hidden ">
                                            <b-row no-gutters>
                                                <b-col md="4" class="text-center mt-4 pl-3">
                                                    <img width="30px" src="../assets/pin.svg">
                                                </b-col>
                                                <b-col md="8">
                                                    <b-card-body>
                                                        <b-card-text v-if="iso639_1 === 'es'" class="mt-2" style="font-size: 10px; font-weight: bold;">
                                                            Características de la ubicación
                                                        </b-card-text>
                                                        <b-card-text v-else class="mt-2" style="font-size: 12px; font-weight: bold;">
                                                            Location Features
                                                        </b-card-text>
                                                    </b-card-body>
                                                </b-col>
                                            </b-row>
                                        </b-card>
    
                                        <b-card no-body class="overflow-hidden opt-active">
                                            <b-row no-gutters>
                                                <b-col md="4" class="text-center mt-4 pl-3">
                                                    <img width="50px" src="../assets/family.svg">
                                                </b-col>
                                                <b-col md="8">
                                                    <b-card-body>
                                                        <b-card-text v-if="iso639_1 === 'es'" class="mt-3" style="font-size: 11px; font-weight: bold;">
                                                            Sobre nosotros
                                                        </b-card-text>
                                                        <b-card-text v-else class="mt-3" style="font-size: 12px; font-weight: bold;">
                                                            About us
                                                        </b-card-text>
                                                    </b-card-body>
                                                </b-col>
                                            </b-row>
                                        </b-card>
    
                                    </b-card-group>
                                    <hr class="custom-100 mb-4 mt-4">
    
                                    <b-card no-body class="mb-4">
                                        <b-card-body class="mb-4">
                                            <b-container fluid style="font-weight: bold;">
                                                <b-row>
                                                    <b-col md="3 mb-4 mt-4" class="col-card-room">
                                                        <b-row class="row-card-room">
                                                            <b-col cols="12" md="12" sm="8">
                                                                <b-card-body class="card-body-room">
                                                                    <b-card-text style="margin-left:60px;">
                                                                        <img width="40px" src="../assets/hombres.png">
                                                                    </b-card-text>
                                                                    <b-card-text v-if="iso639_1 === 'es'" style="margin-left:50px; position:absolute; top:60px;  font-weight: bold;">
                                                                        Hombres
                                                                    </b-card-text>
                                                                    <b-card-text v-else style="margin-left:60px; position:absolute; top:60px;  font-weight: bold;">
                                                                        Mens
                                                                    </b-card-text>
                                                                    <b-card-text style=" position:absolute; top:120px;  font-weight: bold;">

                                                                        <!-- Controles de cantidad -->

                                                                        <b-row style="margin-left:-30px;">                                                                            
                                                                            <b-col cols="4">
                                                                                <!-- Controles de cantidad hombres menus -->
                                                                                <button style="width:40px; border:none; background-color:white;" type="button" @click="validarhombres">
                                                                                      <img width="15px" src="../assets/up-arrow.svg">
                                                                                  </button>
                                                                            </b-col>
                                                                            <b-col cols="4">
                                                                                <input style="border:none;" type="number" name="number" min="0" max="100" v-model="acommodation.caracteristicas.hombres">
                                                                            </b-col>
                                                                            <b-col cols="4">

                                                                                <!-- Controles de cantidad hombres mais -->

                                                                                <button style="width:40px; border:none; background-color:white;" type="button" @click="acommodation.caracteristicas.hombres++">
                                                                                      <img width="15px" src="../assets/down-arrow.svg">
                                                                                  </button>
                                                                            </b-col>
                                                                        </b-row>
                                                                    </b-card-text>
                                                                </b-card-body>
                                                            </b-col>
                                                        </b-row>
                                                    </b-col>
                                                    <b-col md="3 mb-4 mt-4" class="col-card-room">
                                                        <b-row>
                                                            <b-col cols="12" md="12" sm="8">
                                                                <b-card-body>
                                                                    <b-card-text style="margin-left:60px;">
                                                                        <img width="40px" src="../assets/mujeres.png">
                                                                    </b-card-text>
                                                                    <b-card-text v-if="iso639_1 === 'es'" style="margin-left:50px; position:absolute; top:60px;  font-weight: bold;">
                                                                        Mujeres
                                                                    </b-card-text>
                                                                    <b-card-text v-else style="margin-left:50px; position:absolute; top:60px;  font-weight: bold;">
                                                                        Women
                                                                    </b-card-text>
                                                                    <b-card-text style=" position:absolute; top:120px;  font-weight: bold;">
                                                                        <b-row style="margin-left:-30px;">
                                                                        <!-- Controles de cantidad mujeres menos -->                                                                            
                                                                            <b-col cols="4">
                                                                                <button style="width:40px; border:none; background-color:white;" type="button" @click="validarmujeres">
                                                                                      <img width="15px" src="../assets/up-arrow.svg">
                                                                                  </button>
                                                                            </b-col>
                                                                            <b-col cols="4">
                                                                                <input style="border:none;" type="number" name="number" min="0" max="100" v-model="acommodation.caracteristicas.mujeres">
                                                                            </b-col>
                                                                            <!-- Controles de cantidad mujeres mas -->
                                                                            <b-col cols="4">
                                                                                <button style="width:40px; border:none; background-color:white;" type="button" @click="acommodation.caracteristicas.mujeres++">
                                                                                      <img width="15px" src="../assets/down-arrow.svg">
                                                                                  </button>
                                                                            </b-col>
                                                                        </b-row>
                                                                    </b-card-text>
                                                                </b-card-body>
                                                            </b-col>
                                                        </b-row>
                                                    </b-col>
                                                    <b-col md="3 mb-4 mt-4" class="col-card-room">
                                                        <b-row class="row-card-room">
                                                            <b-col cols="12" md="12" sm="8">
                                                                <b-card-body class="card-body-room">
                                                                    <b-card-text style="margin-left:60px;">
                                                                        <img width="40px" src="../assets/ninos.svg">
                                                                    </b-card-text>
                                                                    <b-card-text v-if="iso639_1 === 'es'" style="margin-left:58px; position:absolute; top:60px;  font-weight: bold;">
                                                                        Niños
                                                                    </b-card-text>
                                                                    <b-card-text v-else style="margin-left:50px; position:absolute; top:60px;  font-weight: bold;">
                                                                        Children
                                                                    </b-card-text>
                                                                    <b-card-text style=" position:absolute; top:120px;  font-weight: bold;">
                                                                        <b-row style="margin-left:-30px;">
                                                                            <!-- Controles de cantidad niños menos -->
                                                                            <b-col cols="4">
                                                                                <button style="width:40px; border:none; background-color:white;" type="button" @click="validarninos">
                                                                                      <img width="15px" src="../assets/up-arrow.svg">
                                                                                  </button>
                                                                            </b-col>                                                                            
                                                                            <b-col cols="4">
                                                                                <input style="border:none;" type="number" name="number" min="0" max="100" v-model="acommodation.caracteristicas.ninos">
                                                                            </b-col>
                                                                            <!-- Controles de cantidad niños mas -->
                                                                            <b-col cols="4">
                                                                                <button style="width:40px; border:none; background-color:white;" type="button" @click="acommodation.caracteristicas.ninos++">
                                                                                      <img width="15px" src="../assets/down-arrow.svg">
                                                                                  </button>
                                                                            </b-col>
                                                                        </b-row>
                                                                    </b-card-text>
                                                                </b-card-body>
                                                            </b-col>
                                                        </b-row>
                                                    </b-col>
                                                    <b-col md="3 mb-4 mt-4" class="col-card-room">
                                                        <b-row class="row-card-room">
                                                            <b-col cols="12" md="12" sm="8">
                                                                <b-card-body class="card-body-room">
                                                                    <b-card-text style="margin-left:60px;">
                                                                        <img width="40px" src="../assets/pservicio.svg">
                                                                    </b-card-text>
                                                                    <b-card-text v-if="iso639_1 === 'es'" style="position:absolute; top:60px;  font-weight: bold;">
                                                                        Personal de servicio
                                                                    </b-card-text>
                                                                    <b-card-text v-else style="margin-left:40px; position:absolute; top:60px;  font-weight: bold;">
                                                                        Service staff
                                                                    </b-card-text>
                                                                    <b-card-text style=" position:absolute; top:120px;  font-weight: bold;">
                                                                        <b-row style="margin-left:-30px;">
                                                                            <!-- Controles de cantidad staff menos -->
                                                                            <b-col cols="4">
                                                                                <button style="width:40px; border:none; background-color:white;" type="button" @click="validarpservicio">
                                                                                      <img width="15px" src="../assets/up-arrow.svg">
                                                                                  </button>
                                                                            </b-col>                                                                            
                                                                            <b-col cols="4">
                                                                                <input style="border:none;" type="number" name="number" min="0" max="100" v-model="acommodation.caracteristicas.pservicio">
                                                                            </b-col>
                                                                            <!-- Controles de cantidad staff mais -->
                                                                            <b-col cols="4">
                                                                                <button style="width:40px; border:none; background-color:white;" type="button" @click="acommodation.caracteristicas.pservicio++">
                                                                                      <img width="15px" src="../assets/down-arrow.svg">
                                                                                  </button>
                                                                            </b-col>
                                                                        </b-row>
                                                                    </b-card-text>
                                                                </b-card-body>
                                                            </b-col>
                                                        </b-row>
                                                    </b-col>
                                                    <b-col md="3 mb-4 mt-4" class="col-card-room">
                                                        <b-row class="row-card-room">
                                                            <b-col cols="12" md="12" sm="8">
                                                                <b-card-body class="card-body-room">
                                                                    <b-card-text style="margin-left:60px;">
                                                                        <img width="40px" src="../assets/tedad.png">
                                                                    </b-card-text>
                                                                    <b-card-text v-if="iso639_1 === 'es'" style="margin-left:38px; position:absolute; top:60px;  font-weight: bold;">
                                                                        Tercera Edad
                                                                    </b-card-text>
                                                                    <b-card-text v-else style="margin-left:55px; position:absolute; top:60px;  font-weight: bold;">
                                                                        Seniors
                                                                    </b-card-text>
                                                                    <b-card-text style=" position:absolute; top:120px;  font-weight: bold;">
                                                                        <b-row style="margin-left:-30px;">
                                                                        <!-- Controles de cantidad edad menos -->                                                                            
                                                                            <b-col cols="4">
                                                                                <button style="width:40px; border:none; background-color:white;" type="button" @click="validartedad">
                                                                                      <img width="15px" src="../assets/up-arrow.svg">
                                                                                  </button>
                                                                            </b-col>
                                                                            <b-col cols="4">
                                                                                <input style="border:none;" type="number" name="number" min="0" max="100" v-model="acommodation.caracteristicas.tedad">
                                                                            </b-col>
                                                                            <!-- Controles de cantidad edad mas -->
                                                                            <b-col cols="4">
                                                                                <button style="width:40px; border:none; background-color:white;" type="button" @click="acommodation.caracteristicas.tedad++">
                                                                                      <img width="15px" src="../assets/down-arrow.svg">
                                                                                  </button>
                                                                            </b-col>
                                                                        </b-row>
                                                                    </b-card-text>
                                                                </b-card-body>
                                                            </b-col>
                                                        </b-row>
                                                    </b-col>
                                                    <b-col md="3 mb-4 mt-4" class="col-card-room">
                                                        <b-row class="row-card-room">
                                                            <b-col cols="12" md="12" sm="8">
                                                                <b-card-body class="card-body-room">
                                                                    <b-card-text style="margin-left:60px;">
                                                                        <img width="40px" src="../assets/perros.png">
                                                                    </b-card-text>
                                                                    <b-card-text v-if="iso639_1 === 'es'" style="margin-left:50px; position:absolute; top:60px;  font-weight: bold;">
                                                                        Perros
                                                                    </b-card-text>
                                                                    <b-card-text v-else style="margin-left:60px; position:absolute; top:60px;  font-weight: bold;">
                                                                        Dogs
                                                                    </b-card-text>
                                                                    <b-card-text style=" position:absolute; top:120px;  font-weight: bold;">
                                                                        <b-row style="margin-left:-30px;">
                                                                            <!-- Controles de cantidad perros menos --> 
                                                                            <b-col cols="4">    
                                                                                <button style="width:40px; border:none; background-color:white;" type="button" @click="validarperros">
                                                                                      <img width="15px" src="../assets/up-arrow.svg">
                                                                                  </button>
                                                                            </b-col>
                                                                            <b-col cols="4">
                                                                                <input style="border:none;" type="number" name="number" min="0" max="100" v-model="acommodation.caracteristicas.perros">
                                                                            </b-col>
                                                                            <!-- Controles de cantidad perros mas --> 
                                                                            <b-col cols="4">
                                                                                <button style="width:40px; border:none; background-color:white;" type="button" @click="acommodation.caracteristicas.perros++">
                                                                                    <img width="15px" src="../assets/down-arrow.svg">
                                                                                  </button>
                                                                            </b-col>
                                                                        </b-row>
                                                                    </b-card-text>
                                                                </b-card-body>
                                                            </b-col>
                                                        </b-row>
                                                    </b-col>
                                                    <b-col md="3 mb-4 mt-4" class="col-card-room">
                                                        <b-row class="row-card-room">
                                                            <b-col cols="12" md="12" sm="8">
                                                                <b-card-body class="card-body-room">
                                                                    <b-card-text style="margin-left:60px;">
                                                                        <img width="40px" src="../assets/gatos.png">
                                                                    </b-card-text>
                                                                    <b-card-text v-if="iso639_1 === 'es'" style="margin-left:60px; position:absolute; top:60px;  font-weight: bold;">
                                                                        Gatos
                                                                    </b-card-text>
                                                                    <b-card-text v-else style="margin-left:60px; position:absolute; top:60px;  font-weight: bold;">
                                                                        Cats
                                                                    </b-card-text>
                                                                    <b-card-text style=" position:absolute; top:120px;  font-weight: bold;">
                                                                        <b-row style="margin-left:-30px;">
                                                                            <!-- Controles de cantidad gatos menos --> 
                                                                            <b-col cols="4">
                                                                                <button style="width:40px; border:none; background-color:white;" type="button" @click="validargatos">
                                                                                      <img width="15px" src="../assets/up-arrow.svg">
                                                                                  </button>
                                                                            </b-col>
                                                                            
                                                                            <b-col cols="4">
                                                                                <input style="border:none;" type="number" name="number" min="0" max="100" v-model="acommodation.caracteristicas.gatos">
                                                                            </b-col>

                                                                            <!-- Controles de cantidad gatos mas --> 
                                                                            <b-col cols="4">
                                                                                <button style="width:40px; border:none; background-color:white;" type="button" @click="acommodation.caracteristicas.gatos++">
                                                                                      <img width="15px" src="../assets/down-arrow.svg">
                                                                                  </button>
                                                                            </b-col>
                                                                        </b-row>
                                                                    </b-card-text>
                                                                </b-card-body>
                                                            </b-col>
                                                        </b-row>
                                                    </b-col>
                                                    <b-col md="3 mb-4 mt-4" class="col-card-room">
                                                        <b-row class="row-card-room">
                                                            <b-col cols="12" md="12" sm="8">
                                                                <b-card-body class="card-body-room">
                                                                    <b-card-text style="margin-left:60px;">
                                                                        <img width="40px" src="../assets/omascotas.png">
                                                                    </b-card-text>
                                                                    <b-card-text v-if="iso639_1 === 'es'" style="margin-left:20px; position:absolute; top:60px;  font-weight: bold;">
                                                                        Otras mascotas
                                                                    </b-card-text>
                                                                    <b-card-text v-else style="margin-left:45px; position:absolute; top:60px;  font-weight: bold;">
                                                                        Other pets
                                                                    </b-card-text>
                                                                    <b-card-text style=" position:absolute; top:120px;  font-weight: bold;">
                                                                        <b-row style="margin-left:-30px;">
                                                                            <!-- Controles de cantidad Otras Mascotas menos -->
                                                                            <b-col cols="4">
                                                                                <button style="width:40px; border:none; background-color:white;" type="button" @click="validaromascotas">
                                                                                      <img width="15px" src="../assets/up-arrow.svg">
                                                                                  </button>
                                                                            </b-col>                                                                            

                                                                            <b-col cols="4">
                                                                                <input style="border:none;" type="number" name="number" min="0" max="100" v-model="acommodation.caracteristicas.omascotas">
                                                                            </b-col>

                                                                            <!-- Controles de cantidad Otras Mascotas mas -->
                                                                            <b-col cols="4">
                                                                                <button style="width:40px; border:none; background-color:white;" type="button" @click="acommodation.caracteristicas.omascotas++">
                                                                                      <img width="15px" src="../assets/down-arrow.svg">
                                                                                  </button>
                                                                            </b-col>
                                                                            
                                                                        </b-row>
                                                                    </b-card-text>
                                                                </b-card-body>
                                                            </b-col>
                                                        </b-row>
                                                    </b-col>
                                                </b-row>
                                            </b-container>
                                        </b-card-body>
                                    </b-card>
    
    
                                    <div class="col-12 sobre-nosotros-editable">
                                        <br>
                                        <label v-if="iso639_1 === 'es'" class="title-form">Sobre nosotros</label>
                                        <label v-else class="title-form">About us</label>
                                        <br>
    
                                        <div style="overflow:hidden;" :class="{ 'grande': !expandir }" class="chico">
                                            <button v-if="expandir" @click='expandir = !expandir' style="width:40px; border:none; background-color:transparent; left:calc(100% - 70px); top:calc(100% - 50px); position:absolute;" type="button">
                                                                <img width="25px" src="../assets/up-arrow.svg">
                                                            </button>
                                            <button v-else @click='expandir = !expandir' style="width:40px; border:none; background-color:transparent; left:calc(100% - 70px); top:calc(100% - 60px); position:absolute;" type="button">
                                                                <img width="25px" src="../assets/down-arrow.svg">
                                                            </button>
                                            <textarea v-if="iso639_1 === 'es'" v-model="$v.acommodation.caracteristicas.snosotros.$model" :class="{'is-invalid': $v.acommodation.caracteristicas.snosotros.$error}" placeholder="Debes contarnos sobre los habitantes del alojamiento, cuantos años tienen, a que se dedican y como es la convivencia que esperan tener con el huésped. Está prohibido escribir nombres, direcciones, números y correos de contacto."
                                                class="mt-1" rows="5" cols="50" style="resize: none;"></textarea>
                                            <textarea v-else v-model="$v.acommodation.caracteristicas.snosotros.$model" :class="{'is-invalid': $v.acommodation.caracteristicas.snosotros.$error}" placeholder="You must tell us about the inhabitants of the accommodation, how old they are, what they do and how they live with the guest. It is forbidden to write names, addresses, numbers and contact emails."
                                                class="mt-1" rows="5" cols="50" style="resize: none;"></textarea>
                                        </div>
    
                                        <div v-if="iso639_1 === 'es'">
                                            <p class="text-danger" v-if="!$v.acommodation.caracteristicas.snosotros.required">Este campo es requerido</p>
                                        </div>
                                        <div v-else>
                                            <p class="text-danger" v-if="!$v.acommodation.caracteristicas.snosotros.required">This field is required</p>
                                        </div>
                                    </div>
                                    <!--fin paso 7-->
                                </tab-content>
    
    
                                <tab-content title="Paso 8">
                                    <!--inicio paso 8-->
    
                                    <div class="row mt-4 mb-4 morado height50 hidden-xs">
                                        <div class="avance-wrap mt-2 ">
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">1</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">2</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">3</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">4</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">5</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">6</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">7</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo activo">
                                                <h4 class="h4-numero">8</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">9</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <p v-if="iso639_1 === 'es'">
                                        Sigue los pasos para subir tu propiedad:
                                    </p>
                                    <p v-else>
                                        Follow the steps to upload your property:
                                    </p>
                                    <hr class="custom-100 mb-3">
    
    
                                    <b v-if="iso639_1 === 'es'">Normas de la casa</b>
                                    <b v-else>House's rules</b>
                                    <br>
                                    <div v-if="iso639_1 === 'es'">
                                        Completa las normas de la casa, estas son las reglas que el huésped deberá aceptar antes de reservar.
                                    </div>
                                    <div v-else>
                                        Complete the rules of the house, these are the rules that the guest must accept before booking.
                                    </div>
    
    
                                    <div class="col-12 reglas-generales-box">
                                        <br>
                                        <label v-if="iso639_1 === 'es'" class="title-form">Reglas generales</label>
                                        <label v-else class="title-form">General rules</label>
                                        <br>
                                        <div style="overflow:hidden;" :class="{ 'grande': !expandirt1 }" class="chico">
                                            <button v-if="expandirt1" @click='expandirt1 = !expandirt1' style="width:40px; border:none; background-color:transparent; left:calc(100% - 70px); top:calc(100% - 50px); position:absolute;" type="button">
                                                                <img width="25px" src="../assets/up-arrow.svg">
                                                            </button>
                                            <button v-else @click='expandirt1 = !expandirt1' style="width:40px; border:none; background-color:transparent; left:calc(100% - 70px); top:calc(100% - 60px); position:absolute;" type="button">
                                                                <img width="25px" src="../assets/down-arrow.svg">
                                                            </button>
                                            <textarea v-if="iso639_1 === 'es'" v-model="$v.acommodation.caracteristicas.rgenerales.$model" :class="{'is-invalid': $v.acommodation.caracteristicas.rgenerales.$error}" placeholder="Aquí sólo debes indicar las reglas de comportamiento que debe tener el huésped al vivir en tu alojamiento. Esta censurado hablar de montos de dinero o datos de contacto."
                                                class="mt-1" rows="5" cols="50" style="resize: none;"></textarea>
                                            <textarea v-else v-model="$v.acommodation.caracteristicas.rgenerales.$model" :class="{'is-invalid': $v.acommodation.caracteristicas.rgenerales.$error}" placeholder="Here you should only indicate the rules of behavior that the guest must have when living in your accommodation. It is censored to talk about amounts of money or contact information."
                                                class="mt-1" rows="5" cols="50" style="resize: none;"></textarea>
                                        </div>
                                        <div v-if="iso639_1 === 'es'">
                                            <p class="text-danger" v-if="!$v.acommodation.caracteristicas.rgenerales.required">Este campo es requerido</p>
                                        </div>
                                        <div v-else>
                                            <p class="text-danger" v-if="!$v.acommodation.caracteristicas.rgenerales.required">This field is required</p>
                                        </div>
                                    </div>
    
                                    <div class="col-12 reglas-generales-box">
                                        <br>
                                        <label v-if="iso639_1 === 'es'" class="title-form">Uso espacios comunes</label>
                                        <label v-else class="title-form">I use common spaces</label>
                                        <br>
                                        <div style="overflow:hidden;" :class="{ 'grande': !expandirt2 }" class="chico">
                                            <button v-if="expandirt2" @click='expandirt2 = !expandirt2' style="width:40px; border:none; background-color:transparent; left:calc(100% - 70px); top:calc(100% - 50px); position:absolute;" type="button">
                                                                <img width="25px" src="../assets/up-arrow.svg">
                                                            </button>
                                            <button v-else @click='expandirt2 = !expandirt2' style="width:40px; border:none; background-color:transparent; left:calc(100% - 70px); top:calc(100% - 60px); position:absolute;" type="button">
                                                                <img width="25px" src="../assets/down-arrow.svg">
                                                            </button>
                                            <textarea v-if="iso639_1 === 'es'" v-model="$v.acommodation.caracteristicas.ecomunes.$model" :class="{'is-invalid': $v.acommodation.caracteristicas.ecomunes.$error}" placeholder="Aquí debes indicar a que espacios comunes tiene acceso el huésped y cual es el uso que les puede dar a estos."
                                                class="mt-1" rows="5" cols="50" style="resize: none;"></textarea>
                                            <textarea v-else v-model="$v.acommodation.caracteristicas.ecomunes.$model" :class="{'is-invalid': $v.acommodation.caracteristicas.ecomunes.$error}" placeholder="Here you must indicate to which common spaces the guest has access and what is the use that can be given to them."
                                                class="mt-1" rows="5" cols="50" style="resize: none;"></textarea>
                                        </div>
                                        <div v-if="iso639_1 === 'es'">
                                            <p class="text-danger" v-if="!$v.acommodation.caracteristicas.ecomunes.required">Este campo es requerido</p>
                                        </div>
                                        <div v-else>
                                            <p class="text-danger" v-if="!$v.acommodation.caracteristicas.ecomunes.required">This field is required</p>
                                        </div>
    
                                    </div>
    
                                    <div class="col-12 reglas-generales-box">
                                        <br>
                                        <label v-if="iso639_1 === 'es'" class="title-form">Uso cocina</label>
                                        <label v-else class="title-form">I use kitchen</label>
                                        <br>
                                        <div style="overflow:hidden;" :class="{ 'grande': !expandirt3 }" class="chico">
                                            <button v-if="expandirt3" @click='expandirt3 = !expandirt3' style="width:40px; border:none; background-color:transparent; left:calc(100% - 70px); top:calc(100% - 50px); position:absolute;" type="button">
                                                                <img width="25px" src="../assets/up-arrow.svg">
                                                            </button>
                                            <button v-else @click='expandirt3 = !expandirt3' style="width:40px; border:none; background-color:transparent; left:calc(100% - 70px); top:calc(100% - 60px); position:absolute;" type="button">
                                                                <img width="25px" src="../assets/down-arrow.svg">
                                                            </button>
                                            <textarea v-if="iso639_1 === 'es'" v-model="$v.acommodation.caracteristicas.ucocina.$model" :class="{'is-invalid': $v.acommodation.caracteristicas.ucocina.$error}" placeholder="Aquí debes indicar a que espacios comunes tiene acceso el huésped y cual es el uso que les puede dar a estos."
                                                class="mt-1" rows="5" cols="50" style="resize: none;"></textarea>
                                            <textarea v-else v-model="$v.acommodation.caracteristicas.ucocina.$model" :class="{'is-invalid': $v.acommodation.caracteristicas.ucocina.$error}" placeholder="Here you must indicate to which common spaces the guest has access and what is the use that can be given to them."
                                                class="mt-1" rows="5" cols="50" style="resize: none;"></textarea>
                                        </div>
                                        <div v-if="iso639_1 === 'es'">
                                            <p class="text-danger" v-if="!$v.acommodation.caracteristicas.ucocina.required">Este campo es requerido</p>
                                        </div>
                                        <div v-else>
                                            <p class="text-danger" v-if="!$v.acommodation.caracteristicas.ucocina.required">This field is required</p>
                                        </div>
                                    </div>
    
                                    <div class="col-12 reglas-generales-box">
                                        <br>
                                        <label v-if="iso639_1 === 'es'" class="title-form">Aseo y limpieza</label>
                                        <label v-else class="title-form">Cleaning</label>
                                        <br>
    
                                        <div style="overflow:hidden;" :class="{ 'grande': !expandirt4 }" class="chico">
                                            <button v-if="expandirt4" @click='expandirt4 = !expandirt4' style="width:40px; border:none; background-color:transparent; left:calc(100% - 70px); top:calc(100% - 50px); position:absolute;" type="button">
                                                                <img width="25px" src="../assets/up-arrow.svg">
                                                            </button>
                                            <button v-else @click='expandirt4 = !expandirt4' style="width:40px; border:none; background-color:transparent; left:calc(100% - 70px); top:calc(100% - 60px); position:absolute;" type="button">
                                                                <img width="25px" src="../assets/down-arrow.svg">
                                                            </button>
                                            <textarea v-if="iso639_1 === 'es'" v-model="$v.acommodation.caracteristicas.alimpieza.$model" :class="{'is-invalid': $v.acommodation.caracteristicas.alimpieza.$error}" placeholder="Aquí debes indicar como se realizará el aseo y limpieza dentro del alojamiento, señalando que se espera del huésped en este ámbito."
                                                class="mt-1" rows="5" cols="50" style="resize: none;"></textarea>
                                            <textarea v-else v-model="$v.acommodation.caracteristicas.alimpieza.$model" :class="{'is-invalid': $v.acommodation.caracteristicas.alimpieza.$error}" placeholder="Here you must indicate how the cleaning and cleaning will take place inside the accommodation, indicating that the guest is expected in this area."
                                                class="mt-1" rows="5" cols="50" style="resize: none;"></textarea>
                                        </div>
                                        <div v-if="iso639_1 === 'es'">
                                            <p class="text-danger" v-if="!$v.acommodation.caracteristicas.alimpieza.required">Este campo es requerido</p>
                                        </div>
                                        <div v-else>
                                            <p class="text-danger" v-if="!$v.acommodation.caracteristicas.alimpieza.required">This field is required</p>
                                        </div>
                                    </div>
    
                                    <!--fin paso 8-->
                                </tab-content>
    
                                <tab-content title="Paso 9">
                                    <!--inicio paso 9-->
    
                                    <div class="row mt-4 mb-4 morado height50 hidden-xs">
                                        <div class="avance-wrap mt-2 ">
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">1</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">2</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">3</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">4</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">5</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">6</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">7</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo">
                                                <h4 class="h4-numero">8</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                            <div class="avance-linea"></div>
                                            <div class="avance-circulo activo">
                                                <h4 class="h4-numero">9</h4>
                                                <div class="avance-circulo-interno"></div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <p v-if="iso639_1 === 'es'">
                                        Para nosotros, tu compromiso es importante:
                                    </p>
                                    <p v-else>
                                        For us, your commitment is important:
                                    </p>
                                    <hr class="custom-100 mb-3">
                                    <p v-if="iso639_1 === 'es'">
                                        Ya estás en camino a ser anfitrión de House & Flasts, solo debes acepta estas reglas básicas para ser parte de nuestra plataforma:
                                    </p>
                                    <p v-else>
                                        You are already on your way to host House & Flasts, you just have to accept these basic rules to be part of our platform:
                                    </p>
    
                                    <div class="form-group">
                                        <div class="row">
                                            <div class="col-10">
                                                <br>
    
                                                <div style="overflow:hidden;" :class="{ 'grande': !expandirt5 }" class="chico">
                                                    <button v-if="expandirt5" @click='expandirt5 = !expandirt5' style="width:40px; border:none; background-color:transparent; left:calc(100% - 70px); top:calc(100% - 50px); position:absolute;" type="button">
                                                                        <img width="25px" src="../assets/up-arrow.svg">
                                                                    </button>
                                                    <button v-else @click='expandirt5 = !expandirt5' style="width:40px; border:none; background-color:transparent; left:calc(100% - 70px); top:calc(100% - 60px); position:absolute;" type="button">
                                                                        <img width="25px" src="../assets/down-arrow.svg">
                                                                    </button>
                                                    <textarea v-if="iso639_1 === 'es'" readonly placeholder="Acepto el cobro por servicio de fotografía e inventario por un valor de $20.000 CLP (efectivo y transferencia) o $22.000 CLP (tarjeta débito y tarjeta de crédito). Este servicio consiste en la visita protocolar por parte de House and Flats para validar el alojamiento; corroborar la dirección, primer acercamiento con el anfitrión, realizar las fotografías a mostrar en la plataforma y confeccionar el inventario. La aprobación final de tu alojamiento queda sujeta al pago por este servicio, el cual puede ser realizado por los medios de pago mencionados anteriormente."
                                                        class="mt-1" rows="100" cols="200" style="resize: none; height:200px;"></textarea>
                                                    <textarea v-else readonly placeholder="I accept the charge for photography and inventory service for a value of $ 20,000 CLP (cash and transfer) or $ 22,000 CLP (debit card and credit card). This service consists of the protocol visit by House and Flats to validate the accommodation; corroborate the address, first approach with the host, take the photographs to be displayed on the platform and prepare the inventory. The final approval of your accommodation is subject to payment for this service, which can be done by the payment methods mentioned above."
                                                        class="mt-1" rows="100" cols="200" style="resize: none; height:200px;"></textarea>
                                                </div>
    
                                            </div>
                                            <div class="col-2" style="top:25px;">
                                                <div class="square">
                                                    <input type="checkbox" id="checkbox.r1" v-model="acommodation.caracteristicas.r1">
                                                    <label for="checkbox.r1"></label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="form-group">
                                        <div class="row">
                                            <div class="col-10">
                                                <br>
                                                <div style="overflow:hidden;" :class="{ 'grande': !expandirt6 }" class="chico">
                                                    <button v-if="expandirt6" @click='expandirt6 = !expandirt6' style="width:40px; border:none; background-color:transparent; left:calc(100% - 70px); top:calc(100% - 50px); position:absolute;" type="button">
                                                                        <img width="25px" src="../assets/up-arrow.svg">
                                                                    </button>
                                                    <button v-else @click='expandirt6 = !expandirt6' style="width:40px; border:none; background-color:transparent; left:calc(100% - 70px); top:calc(100% - 60px); position:absolute;" type="button">
                                                                        <img width="25px" src="../assets/down-arrow.svg">
                                                                    </button>
                                                    <textarea v-if="iso639_1 === 'es'" readonly placeholder="Me comprometo a mantener actualizadas las fechas de disponibilidad de mis alojamientos. En House and Flats exigimos mantener actualizadas las fechas de disponibilidad de los alojamientos para un correcto funcionamiento del flujo de los arriendos. ¿Cómo bloqueo la disponibilidad de mi alojamiento? El proceso consiste en ingresar a tu alojamiento, hacer click en el calendario que aparece en la parte superior izquierda de las fotografías e ingresar el periodo en el cual tu alojamiento no estará disponible. "
                                                        class="mt-1" rows="5" cols="50" style="resize: none;"></textarea>
                                                    <textarea v-else readonly placeholder="I accept the charge for photography and inventory service for a value of $ 20,000 CLP (cash and transfer) or $ 22,000 CLP (debit card and credit card). This service consists of the protocol visit by House and Flats to validate the accommodation; corroborate the address, first approach with the host, take the photographs to be displayed on the platform and prepare the inventory. The final approval of your accommodation is subject to payment for this service, which can be done by the payment methods mentioned above."
                                                        class="mt-1" rows="5" cols="50" style="resize: none;"></textarea>
                                                </div>
                                            </div>
                                            <div class="col-2" style="top:25px;">
                                                <div class="square">
                                                    <input type="checkbox" id="checkbox.r2" v-model="acommodation.caracteristicas.r2">
                                                    <label for="checkbox.r2"></label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="form-group">
                                        <div class="row">
                                            <div class="col-10">
                                                <br>
                                                <div style="overflow:hidden;" :class="{ 'grande': !expandirt7 }" class="chico">
                                                    <button v-if="expandirt7" @click='expandirt7 = !expandirt7' style="width:40px; border:none; background-color:transparent; left:calc(100% - 70px); top:calc(100% - 50px); position:absolute;" type="button">
                                                                        <img width="25px" src="../assets/up-arrow.svg">
                                                                    </button>
                                                    <button v-else @click='expandirt7 = !expandirt7' style="width:40px; border:none; background-color:transparent; left:calc(100% - 70px); top:calc(100% - 60px); position:absolute;" type="button">
                                                                        <img width="25px" src="../assets/down-arrow.svg">
                                                                    </button>
                                                    <textarea v-if="iso639_1 === 'es'" readonly placeholder="Declaro que todo lo que forma parte del departamento se mantendrá vigente durante el tiempo que la publicación esté activa, en caso contrario se editarán en el anuncio. En House and Flats exigimos que cualquier modificación en el alojamiento, debe ser transparentado y actualizado en la publicación de cada uno de nuestros anfitriones:
                          - Cambios en las reglas de convivencia
                          - Cambios de artefactos o muebles
                          - Cambios de quienes forman parte del alojamiento
                          - Entre otros
                        Todos estos cambios son notificados vía mail." class="mt-1" rows="5" cols="50" style="resize: none;"></textarea>
                                                    <textarea v-else readonly placeholder="I declare that everything that is part of the department will remain valid for as long as the publication is active, otherwise they will be edited in the announcement. In House and Flats we demand that any modification in the accommodation must be transparent and updated in the publication of each of our hosts:
                          - Changes in the rules of coexistence
                          - Changes of artifacts or furniture
                          - Changes of those who are part of the accommodation
                          - Among others
                        All these changes are notified via mail." class="mt-1" rows="5" cols="50" style="resize: none;"></textarea>
                                                </div>
                                            </div>
                                            <div class="col-2" style="top:25px;">
                                                <div class="square">
                                                    <input type="checkbox" id="checkbox.r3" v-model="acommodation.caracteristicas.r3">
                                                    <label for="checkbox.r3"></label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
    
                                    <div class="form-group">
                                        <div class="row">
                                            <div class="col-10">
                                                <br>
                                                <div style="overflow:hidden;" :class="{ 'grande': !expandirt8 }" class="chico">
                                                    <button v-if="expandirt8" @click='expandirt8 = !expandirt8' style="width:40px; border:none; background-color:transparent; left:calc(100% - 70px); top:calc(100% - 50px); position:absolute;" type="button">
                                                                        <img width="25px" src="../assets/up-arrow.svg">
                                                                    </button>
                                                    <button v-else @click='expandirt8 = !expandirt8' style="width:40px; border:none; background-color:transparent; left:calc(100% - 70px); top:calc(100% - 60px); position:absolute;" type="button">
                                                                        <img width="25px" src="../assets/down-arrow.svg">
                                                                    </button>
                                                    <textarea v-if="iso639_1 === 'es'" readonly placeholder="Coordinar la visita protocolar con máximo 4 días hábiles luego de publicado el anuncio. En House and Flats nos preocupamos por mantener el sitio actualizado constantemente, por lo que exigimos a nuestros anfitriones agendar la visita protocolar con uno de nuestros ejecutivos con un máximo de 4 días hábiles (uno de ellos te contactará) con el fin de que los alojamientos estén disponibles en la plataforma."
                                                        class="mt-1" rows="5" cols="50" style="resize: none;"></textarea>
                                                    <textarea v-else readonly placeholder="Coordinate the protocol visit with a maximum of 4 business days after the announcement is published. In House and Flats we care to keep the site constantly updated, so we require our hosts to schedule the protocol visit with one of our executives with a maximum of 4 business days (one of them will contact you) in order that the accommodations are available on the platform."
                                                        class="mt-1" rows="5" cols="50" style="resize: none;"></textarea>
                                                </div>
                                            </div>
                                            <div class="col-2" style="top:25px;">
                                                <div class="square">
                                                    <input type="checkbox" id="checkbox.r4" v-model="acommodation.caracteristicas.r4">
                                                    <label for="checkbox.r4"></label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
    
                                    <div class="form-group">
                                        <div class="row">
                                            <div class="col-10">
                                                <br>
                                                <div style="overflow:hidden; height:auto;" class="chico">
                                                    <div class="mt-3 mb-3 text-center">
                                                        <a v-if="iso639_1 === 'es'" target="_blank" href="https://houseandflats.com/tyc">He leído y acepto los Términos y Condiciones de House and Flats</a>
                                                        <a v-else target="_blank" href="https://houseandflats.com/tyc">I have read and accept the Terms and Conditions of House and Flats</a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-2" style="top:25px;">
                                                <div class="square">
                                                    <input type="checkbox" id="checkbox.r5" v-model="acommodation.caracteristicas.r5">
                                                    <label for="checkbox.r5"></label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
    
                                    
                                    <div v-show="loader" style="background-color:white;" class="container loader text-center">
                                        <div class="row">
                                            <div class="col-12">
                                                <img style="width:40%" class="img-fluid" src="../assets/logo.png">
                                            </div>
                                            <div class="col-12 gif">
                                                <img src="../assets/load.gif">
                                                <p class="title-sub-2 text-center">Estamos procesando su información</p>
                                            </div>
                                        </div>
                                    </div>
                                    
    
                                    <!--fin paso 9-->
                                </tab-content>
    
                                <template slot="footer" slot-scope="props">
                                                      <div v-if="iso639_1 === 'es'" class="wizard-footer-center">       
                                                        <wizard-button v-if="props.activeTabIndex" v-show="!props.isLastStep || props.isLastStep"  @click.native="props.prevTab()" class="wizard-footer btn-custom2" :style="props.fillButtonStyle">Atras</wizard-button>
                                                        <wizard-button 
                                                        :disabled="!$v.acommodation.direccion.required || !$v.acommodation.m2.required || !$v.acommodation.maximo_huespedes.required || !$v.acommodation.maximo_huespedes.required || !$v.acommodation.maximo_huespedes.minValue"  
                                                        v-if="stepIndex === 0" @click.native="props.nextTab()" 
                                                        class="wizard-footer btn-custom2" 
                                                        :style="props.fillButtonStyle">Siguiente</wizard-button> 
                                                  
                        
                                                        <div style="display: inline;"  v-else-if="stepIndex === 1">              
                                                          <div style="display: inline;"  v-if="diario === true && mensual === false">
                                                          <wizard-button  
                                                          :disabled="!$v.acommodation.vdiario.required || !$v.acommodation.vdiario.numeric || !$v.acommodation.vdiario.minValue"
                                                          @click.native="props.nextTab()" 
                                                          class="wizard-footer btn-custom2" 
                                                          :style="props.fillButtonStyle">Siguiente</wizard-button>
                                                          </div>
                                                        
                        
                                                          <div style="display: inline;"  v-else-if="mensual === true && diario === false">
                                                          <wizard-button   
                                                          :disabled="!$v.acommodation.gastoinmueble.required || !$v.acommodation.gastoinmueble.numeric || !$v.acommodation.gastoinmueble.minValue
                                                          || !$v.acommodation.serviciosb.numeric || !$v.acommodation.gastos_comunes.numeric || !$v.acommodation.limpieza.numeric"   
                                                          @click.native="props.nextTab()" 
                                                          class="wizard-footer btn-custom2" 
                                                          :style="props.fillButtonStyle">Siguiente</wizard-button> 
                                                          </div>
                                                          
                                                          <div style="display: inline;"  v-else-if="diario === true && mensual === true">
                                                          <wizard-button   
                                                          :disabled="!$v.acommodation.gastoinmueble.required || !$v.acommodation.gastoinmueble.numeric || !$v.acommodation.gastoinmueble.minValue
                                                          || !$v.acommodation.serviciosb.numeric || !$v.acommodation.gastos_comunes.numeric || !$v.acommodation.limpieza.numeric
                                                          || !$v.acommodation.vdiario.required || !$v.acommodation.vdiario.numeric || !$v.acommodation.vdiario.minValue"    
                                                          @click.native="props.nextTab()" 
                                                          class="wizard-footer btn-custom2" 
                                                          :style="props.fillButtonStyle">Siguiente</wizard-button> 
                                                          </div>
                        
                                                        </div>
                        
                        
                                                        <wizard-button  
                                                        :disabled="!$v.acommodation.fotos.habitacion.required || !$v.acommodation.fotos.habitacion2.required || 
                                                        !$v.acommodation.fotos.bano.required || !$v.acommodation.fotos.cocina1.required || 
                                                        !$v.acommodation.fotos.cocina2.required || !$v.acommodation.fotos.living.required || !$v.acommodation.fotos.comedor.required ||
                                                        !$v.acommodation.fotos.otro.required"
                                                        v-else-if="stepIndex === 2" @click.native="props.nextTab()" 
                                                        class="wizard-footer btn-custom2" 
                                                        :style="props.fillButtonStyle">Siguiente</wizard-button>     
                        
                                                        <wizard-button  
                                                        v-else-if="stepIndex === 3" @click.native="props.nextTab()" 
                                                        class="wizard-footer btn-custom2" 
                                                        :style="props.fillButtonStyle">Siguiente</wizard-button>   
                                                        
                                                        <wizard-button  
                                                        v-else-if="stepIndex === 4" @click.native="props.nextTab()" 
                                                        class="wizard-footer btn-custom2" 
                                                        :style="props.fillButtonStyle">Siguiente</wizard-button>                                                              
                        
                                                        <wizard-button  
                                                        v-else-if="stepIndex === 5" @click.native="props.nextTab()" 
                                                        class="wizard-footer btn-custom2" 
                                                        :style="props.fillButtonStyle">Siguiente</wizard-button>  
                        
                                                        <wizard-button  
                                                        :disabled="!$v.acommodation.caracteristicas.snosotros.required"
                                                        v-else-if="stepIndex === 6" @click.native="props.nextTab()" 
                                                        class="wizard-footer btn-custom2" 
                                                        :style="props.fillButtonStyle">Siguiente</wizard-button>  
                        
                        
                                                        <wizard-button  
                                                        :disabled="!$v.acommodation.caracteristicas.rgenerales.required || !$v.acommodation.caracteristicas.ecomunes.required
                                                        || !$v.acommodation.caracteristicas.ucocina.required || !$v.acommodation.caracteristicas.alimpieza.required"
                                                        v-else-if="stepIndex === 7" @click.native="props.nextTab()" 
                                                        class="wizard-footer btn-custom2" 
                                                        :style="props.fillButtonStyle">Siguiente</wizard-button>  
                        
                                                        <wizard-button
                                                        :disabled="submitted || !acommodation.caracteristicas.r1 || !acommodation.caracteristicas.r2
                                                        || !acommodation.caracteristicas.r3 || !acommodation.caracteristicas.r4 || !acommodation.caracteristicas.r5"
                                                         v-if="props.isLastStep" 
                                                         @click.native="props.nextTab(), submitted = true" 
                                                         class="wizard-footer btn-custom2" 
                                                         style="width:calc(20% + 210px);" :style="props.fillButtonStyle">Acepto Terminos y condiciones
                                                        </wizard-button>   
                                                                             
                                                      </div>
                                                    <div v-else class="wizard-footer-center">       
                                                        <wizard-button v-if="props.activeTabIndex" v-show="!props.isLastStep || props.isLastStep"  @click.native="props.prevTab()" class="wizard-footer btn-custom2" :style="props.fillButtonStyle">Back</wizard-button>
                                                        <wizard-button 
                                                        :disabled="!$v.acommodation.direccion.required || !$v.acommodation.m2.required || !$v.acommodation.maximo_huespedes.required || !$v.acommodation.maximo_huespedes.required || !$v.acommodation.maximo_huespedes.minValue"  
                                                        v-if="stepIndex === 0" @click.native="props.nextTab()" 
                                                        class="wizard-footer btn-custom2" 
                                                        :style="props.fillButtonStyle">Next</wizard-button> 
                                                  
                        
                                                        <div style="display: inline;"  v-else-if="stepIndex === 1">              
                                                          <div style="display: inline;"  v-if="diario === true && mensual === false">
                                                          <wizard-button  
                                                          :disabled="!$v.acommodation.vdiario.required || !$v.acommodation.vdiario.numeric || !$v.acommodation.vdiario.minValue"
                                                          @click.native="props.nextTab()" 
                                                          class="wizard-footer btn-custom2" 
                                                          :style="props.fillButtonStyle">Next</wizard-button>
                                                          </div>
                                                        
                        
                                                          <div style="display: inline;"  v-else-if="mensual === true && diario === false">
                                                          <wizard-button   
                                                          :disabled="!$v.acommodation.gastoinmueble.required || !$v.acommodation.gastoinmueble.numeric || !$v.acommodation.gastoinmueble.minValue
                                                          || !$v.acommodation.serviciosb.numeric || !$v.acommodation.gastos_comunes.numeric || !$v.acommodation.limpieza.numeric"   
                                                          @click.native="props.nextTab()" 
                                                          class="wizard-footer btn-custom2" 
                                                          :style="props.fillButtonStyle">Next</wizard-button> 
                                                          </div>
                                                          
                                                          <div style="display: inline;"  v-else-if="diario === true && mensual === true">
                                                          <wizard-button   
                                                          :disabled="!$v.acommodation.gastoinmueble.required || !$v.acommodation.gastoinmueble.numeric || !$v.acommodation.gastoinmueble.minValue
                                                          || !$v.acommodation.serviciosb.numeric || !$v.acommodation.gastos_comunes.numeric || !$v.acommodation.limpieza.numeric
                                                          || !$v.acommodation.vdiario.required || !$v.acommodation.vdiario.numeric || !$v.acommodation.vdiario.minValue"    
                                                          @click.native="props.nextTab()" 
                                                          class="wizard-footer btn-custom2" 
                                                          :style="props.fillButtonStyle">Next</wizard-button> 
                                                          </div>
                        
                                                        </div>
                        
                        
                                                        <wizard-button  
                                                        :disabled="!$v.acommodation.fotos.habitacion.required || !$v.acommodation.fotos.habitacion2.required || 
                                                        !$v.acommodation.fotos.bano.required || !$v.acommodation.fotos.cocina1.required || 
                                                        !$v.acommodation.fotos.cocina2.required || !$v.acommodation.fotos.living.required || !$v.acommodation.fotos.comedor.required ||
                                                        !$v.acommodation.fotos.otro.required"
                                                        v-else-if="stepIndex === 2" @click.native="props.nextTab()" 
                                                        class="wizard-footer btn-custom2" 
                                                        :style="props.fillButtonStyle">Next</wizard-button>     
                        
                                                        <wizard-button  
                                                        v-else-if="stepIndex === 3" @click.native="props.nextTab()" 
                                                        class="wizard-footer btn-custom2" 
                                                        :style="props.fillButtonStyle">Next</wizard-button>   
                                                        
                                                        <wizard-button  
                                                        v-else-if="stepIndex === 4" @click.native="props.nextTab()" 
                                                        class="wizard-footer btn-custom2" 
                                                        :style="props.fillButtonStyle">Next</wizard-button>                                                              
                        
                                                        <wizard-button  
                                                        v-else-if="stepIndex === 5" @click.native="props.nextTab()" 
                                                        class="wizard-footer btn-custom2" 
                                                        :style="props.fillButtonStyle">Next</wizard-button>  
                        
                                                        <wizard-button  
                                                        :disabled="!$v.acommodation.caracteristicas.snosotros.required"
                                                        v-else-if="stepIndex === 6" @click.native="props.nextTab()" 
                                                        class="wizard-footer btn-custom2" 
                                                        :style="props.fillButtonStyle">Next</wizard-button>  
                        
                        
                                                        <wizard-button  
                                                        :disabled="!$v.acommodation.caracteristicas.rgenerales.required || !$v.acommodation.caracteristicas.ecomunes.required
                                                        || !$v.acommodation.caracteristicas.ucocina.required || !$v.acommodation.caracteristicas.alimpieza.required"
                                                        v-else-if="stepIndex === 7" @click.native="props.nextTab()" 
                                                        class="wizard-footer btn-custom2" 
                                                        :style="props.fillButtonStyle">Next</wizard-button>  
                        
                                                        <wizard-button
                                                        :disabled="submitted || !acommodation.caracteristicas.r1 || !acommodation.caracteristicas.r2
                                                        || !acommodation.caracteristicas.r3 || !acommodation.caracteristicas.r4 || !acommodation.caracteristicas.r5"
                                                         v-if="props.isLastStep" 
                                                         @click.native="props.nextTab(), submitted = true" 
                                                         class="wizard-footer btn-custom2" 
                                                         style="width:calc(20% + 210px);" :style="props.fillButtonStyle">I accept terms and conditions
                                                        </wizard-button>   
                                                                             
                                                      </div>
</template>

                        </form-wizard>
                      </div>
                  </div>
                  <!--fin seccion inputs-->
              </div>
            </div>
        </div>    
    </div>
</template>

<script>
import { required, email, sameAs, numeric, alphaNum, minValue } from 'vuelidate/lib/validators'
import VueGoogleAutocomplete from 'vue-google-autocomplete'
import { mapActions, mapState } from "vuex";
import Navbar from '@/components/Navbar.vue'
import Controls from '@/components/Controls.vue'
import Steps from '@/components/Steps.vue'
import router from '@/router'
import Vue from 'vue'
import Room from '@/components/Room'

export default {
    name: 'RegistroAlojamiento',
    data() {
        return {
            titulo: '',
            tip: '',
            expandir: true,
            expandirt1: true,
            expandirt2: true,
            expandirt3: true,
            expandirt4: true,
            expandirt5: true,
            expandirt6: true,
            expandirt7: true,
            expandirt8: true,
            submitted: false,
            acommodation: {
                full_name: '',
                direccion: '',
                numero: null,
                ndc: null,
                m2: null,
                habitaciones: '',
                maximo_huespedes: 1,
                tipo: 'entero',
                arriendo: this.total,
                gastoinmueble: null,
                serviciosb: null,
                limpieza: null,
                gastos_comunes: null,
                vdiario: null,
                caracteristicas: {
                    rgenerales: '',
                    ecomunes: '',
                    ucocina: '',
                    alimpieza: '',
                    conserje: 0,
                    timbre: 0,
                    bodega: 0,
                    eprivado: 0,
                    evisita: 0,
                    ebicicleta: 0,
                    sestar: 0,
                    seventos: 0,
                    jardines: 0,
                    piscina: 0,
                    gimnasio: 0,
                    desayuno: 0,
                    refrigerador: 0,
                    cocina: 0,
                    microondas: 0,
                    parrilla: 0,
                    horno: 0,
                    lavadora: 0,
                    secadora: 0,
                    plancha: 0,
                    limpieza: 0,
                    mascotas: 0,
                    cama2p: 0,
                    bcompartido: 0,
                    camam: 0,
                    cama1p: 0,
                    bprivado: 0,
                    camarote: 0,
                    velador: 0,
                    scama: 0,
                    closet: 0,
                    esilla: 0,
                    acondicionado: 0,
                    rcama: 0,
                    calefaccion: 0,
                    wifi: 0,
                    secador: 0,
                    tv: 0,
                    colgadores: 0,
                    ventilador: 0,
                    metro: 0,
                    paradero: 0,
                    csalud: 0,
                    supermercado: 0,
                    banco: 0,
                    znocturna: 0,
                    averdes: 0,
                    comercial: 0,
                    civico: 0,
                    gimnasioe: 0,
                    hombres: 0,
                    mujeres: 0,
                    ninos: 0,
                    pservicio: 0,
                    tedad: 0,
                    perros: 0,
                    gatos: 0,
                    omascotas: 0,
                    snosotros: '',
                    r1: false,
                    r2: false,
                    r3: false,
                    r4: false,
                    r5: false
                },
                fotos: {
                    habitacion: null,
                    habitacion2: null,
                    bano: null,
                    cocina1: null,
                    cocina2: null,
                    living: null,
                    comedor: null,
                    otro: null
                },
                pieza: [],
                tipo_moneda: 'es_CLP'
            },
            toggle: true,
            mobile: true,
            casa: true,
            departamento: true,
            habitacion: true,
            hcompartida: true,
            residencia: true,
            modalidad: true,
            foo: 'NO APLICA',
            foo2: 'DOES NOT APPLY',
            entero: true,
            diario: true,
            mensual: false,
            ambos: false,
            from_address: {},
            to_address: {},
            stepIndex: 0,
            numeroh: 0,
            preview: {
                habitacion: null,
                habitacion2: null,
                bano: null,
                cocina1: null,
                cocina2: null,
                living: null,
                comedor: null,
                otro: null
            }
        }
    },
    validations: {
        acommodation: {
            direccion: { required },
            numero: { required, numeric, minValue: minValue(1) },
            ndc: { alphaNum },
            m2: { required, numeric, minValue: minValue(1) },
            maximo_huespedes: { required, numeric, minValue: minValue(1) },
            gastoinmueble: { required, numeric, minValue: minValue(1) },
            serviciosb: { numeric },
            gastos_comunes: { numeric },
            limpieza: { numeric },
            vdiario: { required, numeric, minValue: minValue(1) },
            fotos: {
                habitacion: { required },
                habitacion2: { required },
                bano: { required },
                cocina1: { required },
                cocina2: { required },
                living: { required },
                comedor: { required },
                otro: { required }
            },
            caracteristicas: {
                snosotros: { required },
                rgenerales: { required },
                ecomunes: { required },
                ucocina: { required },
                alimpieza: { required }
            }
        }
    },
    components: {
        Navbar,
        Controls,
        Steps,
        VueGoogleAutocomplete
    },
    methods: {
        ...mapActions(['registerAcommodation', 'setMonedaCambio']),
        
        vcasa: function() {
            if (this.casa = true) {
                this.casa = false
                this.departamento = true
                this.habitacion = true
                this.hcompartida = true
                this.acommodation.tipo = 'entero'
                this.entero = true;
            }
        },
        vdepartamento: function() {
            if (this.departamento = true) {
                this.departamento = false
                this.casa = true
                this.habitacion = true
                this.hcompartida = true
                this.acommodation.tipo = 'entero'
                this.entero = true;
            }
        },
        vhabitacion: function() {
            if (this.habitacion = true) {
                this.habitacion = false
                this.casa = true
                this.departamento = true
                this.hcompartida = true
                this.acommodation.tipo = 'privado'
                this.entero = false;
            }
        },
        vhcompartida: function() {
            if (this.hcompartida = true) {
                this.hcompartida = false
                this.casa = true
                this.departamento = true
                this.habitacion = true
                this.acommodation.tipo = 'compartido'
                this.entero = false;
            }
        },

        //Añade un nuevo ambiente
        duplicate() {
            this.numeroh++
                var ComponentClass = Vue.extend(Room)
            var instance = new ComponentClass({
                propsData: { numeroh: this.numeroh, iso639_1: this.iso639_1 }
            })
            instance.$mount()
            this.acommodation.pieza.push(instance.pieza);
            this.$refs.container.appendChild(instance.$el)
        },
        getFromAddress(from_address, placeResultData, id) {
            //this.from_address = from_address;
            //console.log(from_address);
        },
        getToAddress(to_address, placeResultData, id) {
            //this.to_address = to_address;
            this.acommodation.direccion = to_address;
            this.acommodation.full_name = placeResultData.formatted_address
        },
        handleError(error) {
            // alert(error)
        },
        changeDiario() {
            if (!this.diario) {
                this.mensual = false
                this.ambos = false
            } else {
                this.mensual = true
                this.ambos = false
            }
        },
        changeMensual() {
            if (!this.mensual) {
                this.diario = false
                this.ambos = false
            } else {
                this.diario = true
                this.ambos = false
            }
        },
        changeAmbos() {
            this.mensual = true
            this.diario = true
        },
        validarhombres() {
            if (!this.acommodation.caracteristicas.hombres <= 0) {
                this.acommodation.caracteristicas.hombres--
            }
        },
        validarmujeres() {
            if (!this.acommodation.caracteristicas.mujeres <= 0) {
                this.acommodation.caracteristicas.mujeres--
            }
        },
        validarninos() {
            if (!this.acommodation.caracteristicas.ninos <= 0) {
                this.acommodation.caracteristicas.ninos--
            }
        },
        validarpservicio() {
            if (!this.acommodation.caracteristicas.pservicio <= 0) {
                this.acommodation.caracteristicas.pservicio--
            }
        },
        validartedad() {
            if (!this.acommodation.caracteristicas.tedad <= 0) {
                this.acommodation.caracteristicas.tedad--
            }
        },
        validartedad() {
            if (!this.acommodation.caracteristicas.tedad <= 0) {
                this.acommodation.caracteristicas.tedad--
            }
        },
        validarperros() {
            if (!this.acommodation.caracteristicas.perros <= 0) {
                this.acommodation.caracteristicas.perros--
            }
        },
        validargatos() {
            if (!this.acommodation.caracteristicas.gatos <= 0) {
                this.acommodation.caracteristicas.gatos--
            }
        },
        validaromascotas() {
            if (!this.acommodation.caracteristicas.omascotas <= 0) {
                this.acommodation.caracteristicas.omascotas--
            }
        },
        onFileChangeHabitacion(e) {
            const file = e.target.files[0];
            if (file) {
                this.preview.habitacion = URL.createObjectURL(file);
            } else {
                this.preview.habitacion = null;
            }
        },
        onFileChangeHabitacion2(e) {
            const file = e.target.files[0];
            if (file) {
                this.preview.habitacion2 = URL.createObjectURL(file);
            } else {
                this.preview.habitacion2 = null;
            }
        },
        onFileChangeBano(e) {
            const file = e.target.files[0];
            if (file) {
                this.preview.bano = URL.createObjectURL(file);
            } else {
                this.preview.bano = null;
            }
        },
        onFileChangeCocina(e) {
            const file = e.target.files[0];
            if (file) {
                this.preview.cocina = URL.createObjectURL(file);
            } else {
                this.preview.cocina = null;
            }
        },
        onFileChangeCocina2(e) {
            const file = e.target.files[0];
            if (file) {
                this.preview.cocina2 = URL.createObjectURL(file);
            } else {
                this.preview.cocina2 = null;
            }
        },
        onFileChangeLiving(e) {
            const file = e.target.files[0];
            if (file) {
                this.preview.living = URL.createObjectURL(file);
            } else {
                this.preview.living = null;
            }
        },
        onFileChangeComedor(e) {
            const file = e.target.files[0];
            if (file) {
                this.preview.comedor = URL.createObjectURL(file);
            } else {
                this.preview.comedor = null;
            }
        },
        onFileChangeOtro(e) {
            const file = e.target.files[0];
            if (file) {
                this.preview.otro = URL.createObjectURL(file);
            } else {
                this.preview.otro = null;
            }
        },
        cambiarTip(titulo, mensaje) {
            this.titulo = titulo
            this.tip = mensaje
        },
        cambiarMilles(valor){

            let numero = Number(valor);
                numero = numero.toFixed(2).split('.');
                numero[0] = numero[0].split(/(?=(?:...)*$)/).join('.');               

            if(this.acommodation.tipo_moneda != 'es_CLP'){
                numero = numero.join(',')
                return numero;
            }    

            return numero[0];  
            
        }
    },
    computed: {
        ...mapState(['iso639_1', 'loader', 'tipocambio', 'accomodation.tipo_moneda']),
        total: function() {

            let gasto_inmueble = this.acommodation.gastoinmueble != null ? Number(this.acommodation.gastoinmueble) : 0;
            let serviciosb = this.acommodation.gastoinmueble != null ? Number(this.acommodation.serviciosb) : 0;
            let gastos_comunes = this.acommodation.gastoinmueble != null ? Number(this.acommodation.gastos_comunes) : 0;
            let limpieza = this.acommodation.gastoinmueble != null ? Number(this.acommodation.limpieza) : 0;
            let arriendo =  gasto_inmueble + serviciosb + gastos_comunes + limpieza;
            
            

            if (this.mensual) {
                this.acommodation.arriendo = arriendo
                //this.acommodation.vdiario = 0
            } else {
                //esto queda asi mientras se resuleve la formula diaria
                //this.acommodation.arriendo = this.acommodation.vdiario
                this.acommodation.arriendo = this.acommodation.vdiario                
                
            }
            

            return this.cambiarMilles(arriendo)
        },
    },
    created() {
        this.casa = false;
    },
    mounted() {
        this.$nextTick(function() {
            this.duplicate()
        })
    }
}
</script>


<style scoped>

.close-pic{
    position: absolute;
    font-size: 15px;
    right: 25px;
    border: 2px solid red;
    line-height: 10px;
    padding: 4px;
    border-radius: 50%;
    top: 10px;
    color: red;
    z-index: 1000;
    background: #FFF;
    cursor: pointer;
    font-weight: bold;
}
.dot {
    height: 25px;
    width: 25px;
    background-color: #F7F7F7;
    border-radius: 50%;
    display: inline-block;
    border: 1px;
    color: #5A287F;
    border-style: solid;
    border-width: 1px;
    border-color: #5A287F;
}

.btn-custom-fixed {
    background-color: #5A287F;
    color: white;
    width: 35px;
    height: 60px;
    position: absolute;
    left: -50px;
    top: 60px;
}

@media (max-width: 991px) {
    .btn-custom-fixed {
        display: none;
    }
}

.opt-active {
    background-color: #5A287F;
    color: #FFFFFF;
    border-radius: 0;
}

.total {
    background-color: #5A287F;
    position: absolute;
    top: 150px;
    width: auto;
}

.card-footer {
    background-color: #5A287F;
    color: white;
}

.recibe {
    background-color: #5A287F;
    color: white;
}

.o-container {
    padding-top: 40px;
    padding-bottom: 40px;
}

.c-field__error {
    font-size: 12px;
    color: #d71149;
}

.c-file-input {
    position: relative;
    display: block;
    height: 200px;
    width: 100%;
    border: 2px dashed #5A287F;
    background-color: #fff;
}

/* line 24, app/assets/stylesheets/mweb/6-components/_components.file-input.scss */

.c-file-input:invalid,
.c-field--error .c-file-input {
    background-color: #ffe6e9;
    border-color: #ff566a;
}

/* line 28, app/assets/stylesheets/mweb/6-components/_components.file-input.scss */

.c-file-input:invalid:focus,
.c-field--error .c-file-input:focus {
    background-color: #ffe6e9;
    border-color: #ff566a;
}

/* line 34, app/assets/stylesheets/mweb/6-components/_components.file-input.scss */

.c-file-input__label {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding-left: 36px;
    padding-right: 36px;
    line-height: 36px;
    color: #999;
    font-size: 12px;
    overflow: hidden;
    word-wrap: break-word;
    z-index: 1;
}

/* line 50, app/assets/stylesheets/mweb/6-components/_components.file-input.scss */

.c-file-input__field {
    position: absolute !important;
    height: 1px !important;
    width: 1px !important;
    padding: 0 !important;
    overflow: hidden !important;
    clip: rect(0, 0, 0, 0) !important;
    z-index: -1;
}

/* line 59, app/assets/stylesheets/mweb/6-components/_components.file-input.scss */

.c-file-input__field:focus {
    outline: none;
}

/* line 64, app/assets/stylesheets/mweb/6-components/_components.file-input.scss */

.c-file-input__indicator {
    position: absolute;
    left: calc(60% - 62px);
    top: 30px;
    height: 100%;
    width: 86px;
    z-index: 0;
}

/* line 73, app/assets/stylesheets/mweb/6-components/_components.file-input.scss */

.c-file-input__indicator__icon {
    color: #bbb;
    position: absolute;
    top: 50%;
    -webkit-transform: translate(0, -50%);
    -ms-transform: translate(0, -50%);
    -o-transform: translate(0, -50%);
    transform: translate(0, -50%);
    left: 4px;
    font-size: 20px;
}

/* line 81, app/assets/stylesheets/mweb/6-components/_components.file-input.scss */

.has-file .c-file-input__indicator__icon {
    color: #d71149;
}

/* line 86, app/assets/stylesheets/mweb/6-components/_components.file-input.scss */

.c-file-input__remove {
    display: none;
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    width: 36px;
    z-index: 2;
}

.has-file>.c-file-input__remove {
    display: block;
}

/* line 100, app/assets/stylesheets/mweb/6-components/_components.file-input.scss */

.c-file-input__remove__icon {
    position: absolute;
    top: 50%;
    -webkit-transform: translate(0, -50%);
    -ms-transform: translate(0, -50%);
    -o-transform: translate(0, -50%);
    transform: translate(0, -50%);
    left: 4px;
    font-size: 20px;
    color: #ff566a;
}

.cortar {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.morado {
    background-color: #5A287F;
}

.height50 {
    height: 50px;
}

.avance-circulo.activo {
    background-color: #94C11F;
    border-style: solid;
    border-width: 1px;
    border-color: #94C11F;
}

.avance-circulo {
    color: #94C11F;
    border-style: solid;
    border-width: 1px;
    border-color: #94C11F;
}

@media (max-width: 768px) {
    .hidden-xs {
        display: none !important;
    }
}

.round {
    position: relative;
}

.round label {
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 50%;
    cursor: pointer;
    height: 28px;
    left: 0;
    position: absolute;
    top: 0;
    width: 28px;
}

.round label:after {
    border: 2px solid #fff;
    border-top: none;
    border-right: none;
    content: "";
    height: 6px;
    left: 7px;
    opacity: 0;
    position: absolute;
    top: 8px;
    transform: rotate(-45deg);
    width: 12px;
}

.round input[type="checkbox"] {
    visibility: hidden;
}

.round input[type="checkbox"]:checked+label {
    background-color: #5A287F;
    border-color: #5A287F;
}

.round input[type="checkbox"]:checked+label:after {
    opacity: 0;
}

.square {
    position: relative;
}

.square label {
    background-color: #fff;
    border: 1px solid #ccc;
    cursor: pointer;
    height: 55px;
    left: 0;
    position: absolute;
    top: 0;
    width: 55px;
}

.square label:after {
    border: 2px solid #fff;
    border-top: none;
    border-right: none;
    content: "";
    height: 6px;
    left: 7px;
    opacity: 0;
    position: absolute;
    top: 8px;
    transform: rotate(-45deg);
    width: 12px;
}

.square input[type="checkbox"] {
    visibility: hidden;
}

.square input[type="checkbox"]:checked+label {
    box-shadow: 2px 3px 5px 0px rgba(153, 145, 153, 1);
}

.square input[type="checkbox"]+label {
    box-shadow: 2px 3px 5px 0px rgba(153, 145, 153, 1);
}

.square input[type="checkbox"]:checked+label:after {
    opacity: 1;
    border-color: #5A287F;
    width: 40px;
    height: 15px;
    top: 20px;
}

.square input[type="radio"] {
    visibility: hidden;
}

.square input[type="radio"]:checked+label {
    box-shadow: 2px 3px 5px 0px rgba(153, 145, 153, 1);
}

.square input[type="radio"]+label {
    box-shadow: 2px 3px 5px 0px rgba(153, 145, 153, 1);
}

.square input[type="radio"]:checked+label:after {
    opacity: 1;
    border-color: #5A287F;
    width: 30px;
    height: 15px;
}

textarea::-webkit-scrollbar {
    width: 0.6em;
}

textarea::-webkit-scrollbar-thumb {
    background-color: #707070;
}

textarea {
    width: calc(100% - 80px);
    height: auto;
    border: none;
    background-color: transparent;
}

textarea:focus {
    outline: none;
}

textarea::-webkit-scrollbar-button:start:decrement,
textarea::-webkit-scrollbar-button:end:increment {
    height: 10px;
    background-color: transparent;
}

textarea::-webkit-scrollbar-thumb:vertical {
    height: 10px;
    background-color: #666;
    border: 1px solid #eee;
    border-radius: 16px;
}

.chico {
    border: 1px solid rgba(90, 40, 127, 0.3);
    width: auto;
    height: 55px;
    background-color: white;
    box-shadow: 2px 3px 5px 0px rgba(153, 145, 153, 1);
    text-indent: 10px;
}

.grande {
    border: 1px solid rgba(90, 40, 127, 0.3);
    width: auto;
    height: auto;
    background-color: white;
    box-shadow: 2px 3px 5px 0px rgba(153, 145, 153, 1);
    text-indent: 10px;
}

textarea::placeholder {
    vertical-align: middle;
}

.loader {
    position: absolute;
    top: 25%;
    left: -10%;
    z-index: 500;
}

@media (max-width: 768px) {
    .loader {
        position: absolute;
        top: 40%;
        left: 0%;
        z-index: 500;
        margin-bottom: 20px;
    }
}

.gif {
    top: -120px;
}

@media (max-width: 768px) {
    .gif {
        top: 0px;
    }
}
</style>


